export default {
  salesCenter: {
  caseLabel: '案例',
  viewCount: '浏览',
  viewRule: '查看规则',
  collectCount: '收藏',
  outboundCaller: '外呼人',
  /** 外呼记录-筛选区（避免与普通 time/status/auto_653 冲突） */
  outboundRecordsQueryTime: '查询时间：',
  outboundRecordsCallDuration: '通话时长：',
  outboundRecordsPhoneStatus: '号码状态',
  callTypeOutbound: '外呼',
  callType: '呼叫方式',
  activityId: '活动ID',
  aboutToRecycle: '即将回收',
  above6000: '6000人以上',
  accountActivateDate: '账户激活日期',
  accountActivateDateLabel: '账户激活日期：',
  dispatchDate: '发货日期',
  accountActivateTime: '账户激活时间',
  accountLabel: '账号',
  outCallAgentLoginMode: '座席账号登录',
  accountPhoneRebind: '账户手机换绑',
  accountStatus: '账户状态',
  accountStatusLabel: '账户状态：',
  backActivityList: '返回活动列表',
  accountValidPeriod: '账户有效期',
  activate: '已激活',
  activated: '已激活',
  activity: '活动',
  activityCreateFail: '活动创建失败',
  activityCreateSuccess: '活动创建成功',
  createActivityButton: '创建活动',
  activityStatusNotStarted: '未开始',
  activityStatusInProgress: '进行中',
  activityStatusEnded: '已结束',
  copyLinkLabel: '复制链接',
  inviteRewardPeopleSuffix: '人赠送',
  inStoreRewardPeopleSuffix: '人奖励',
  activityDeleteFail: '活动删除失败',
  activityDeleteSuccess: '活动删除成功',
  activityEditFail: '活动编辑失败',
  activityEditSuccess: '活动编辑成功',
  activityName: '活动名称',
  activityPauseFail: '活动暂停失败',
  activityPauseSuccess: '活动暂停成功',
  activityPublishFail: '活动发布失败',
  activityPublishSuccess: '活动发布成功',
  activityStartFail: '活动开始失败',
  activityStartSuccess: '活动开始成功',
  activityTemplateTitle: '营销活动模板',
  /** 活动图库-新增活动模板按钮（勿用 auto_530，该键为「初中」学段） */
  activityGalleryAddNewTemplate: '新增活动模板',
  actualReturnAmount: '柜台累计已返金额',
  actualVisitTime: '到访时间:',
  actualVisitTip: '客户实际到访门店的时间',
  adapAccountLabel: '智适应账号：',
  adaptiveAccountLabel: '智适应账号：',
  pleaseSelectAdaptiveAccount: '请选择智适应账号',
  add: '新增',
  addCounter: '+新增柜台',
  addExamInfo: '新增考试信息',
  addFollowRecord: '添加跟进记录',
  addLead: '添加线索',
  addReport: '新增报备',
  addScoreFail: '新增成绩失败',
  addSingleImage: '新增单个图片',
  addSubTag: '添加子标签',
  addSuccess: '添加成功',
  addTagType: '添加标签类型',
  addTemplate: '新增',
  addUserProfile: '新增用户档案',
  addVideo: '新增视频',
  addressTooShort: '地址过于简略，请详细填写',
  adjustTable: '调节表格展示',
  admissionCannotExceedFinalScore: '入学成绩不能大于结课成绩',
  admissionScoreCannotExceedSubjectTotal: '入学成绩不能大于学科总分',
  admissionScoreCannotExceedTotal: '录取分数不能大于总分',
  admissionScoreFormatError: '入学成绩格式不正确',
  admissionScoreLabel: '录取分数',
  admissionStageGrade: '入学阶段年级',
  admissionStageCannotExceedCurrent: '入学年级阶段不能高于当前阶段年级',
  agent: '所属地代理商',
  agentId: '代理商ID',
  agentLabel: '代理商',
  agentName: '代理商名称',
  agreeTransfer: '同意转入',
  all: '全部',
  allLeads: '全部线索',
  allocated: '已分配',
  allocation: '分配',
  already: '已订阅',
  alreadyExpired: '已',
  analystLabel: '分析师：',
  analystPersonLabel: '分析师人员',
  applySuccess: '申请成功',
  applyTimeLabel: '申请时间：',
  applyTransfer: '申请转入',
  appointmentTimeAfterNow: '选择时间需要大于当前时间',
  approvalFailed: '审批失败',
  approvalSuccess: '审批成功',
  assignAnalyst: '分配分析师',
  assignSuccess: '分配成功',
  assignTo: '分配给：',
  audit: '审核人',
  auditBy: '确认人',
  auditRejectReason: '审核驳回原因',
  auditRejectTip: '你提交申报的"{name}"学校未通过审核，原因是："{remark}"，请修改完成后重新提交！',
  auditRemark: '确认备注',
  auditStatus: '审核状态',
  auditTime: '确认时间',
  availablePrototypeCount: '可标记样机数',
  back: '返回',
  basicInfo: '基本信息',
  batchAllocation: '批量分配',
  batchAllocationFailed: '批量分配失败',
  batchAllocationSuccess: '批量分配成功',
  batchAllocationTitle: '批量分配',
  batchAssignAnalyst: '批量分配分析师',
  batchAssignAnalystTitle: '批量分配分析师',
  batchAssignFollowPerson: '批量分配跟进人',
  batchAssignServicePerson: '批量分配服务人员',
  batchAllocateFollower: '批量分配跟进人',
  batchClaim: '批量认领',
  batchCollection: '批量领取',
  batchCollectionFailed: '批量领取失败',
  batchCollectionSuccess: '批量领取成功',
  batchExport: '批量导出',
  batchImport: '批量导入',
  batchImportBusy: '当前使用批量导入的人数较多，服务繁忙，请您10分钟后再试',
  batchImportLead: '批量导入线索',
  batchOperation: '批量操作：',
  batchRecall: '批量收回',
  batchRecover: '批量收回',
  batchRecoverSuccess: '批量收回成功',
  batchRelease: '批量释放',
  batchReleaseSuccess: '批量释放成功',
  batchRestore: '批量还原',
  batchRestoreSuccess: '批量还原成功',
  batchSaveTip: '，每次保存不多于5张图片',
  batchUploadImages: '批量上传图片',
  batchUploadTip: '注释：批量上传多张图片，图片名称将自动编号，例如："每日一图01"，如需修改可在图库列表编辑',
  bayear: '八年级',
  below2000: '2000人以下',
  bestSize: '最佳尺寸1080x1920',
  between2000and4000: '2000~4000人',
  between4000and6000: '4000~6000人',
  bianji: '最后编辑人',
  bindFailed: '绑定失败',
  bindPhoneTip: '此账号末绑定手机号，无法更换服务中心。请先绑定手机号后再试。',
  bindPhoneTitle: '账号绑定手机号',
  bindSuccess: '绑定成功',
  birthDate: '出生日期:',
  birthDateLabel: '出生日期',
  birthDateLabelShort: '出生日期：',
  businessStatus: '营业状态',
  buttonPicLabel: '按钮图片:',
  campus: '校区',
  cancel: '取 消',
  cancelCreateDone: '已取消创建',
  cancelDeleteDone: '已取消删除',
  cancelFollow: '取消跟进',
  cancelFollowReasonTip: '取消跟进需填写取消的原因',
  cancelFollowSuccess: '取消跟进成功',
  cancelPauseDone: '已取消暂停',
  cancelPublish: '取消发布',
  cancelPublishDone: '已取消发布',
  cancelPublishFailed: '取消发布失败',
  cancelPublishSuccess: '取消发布成功',
  cancelReason: '取消原因:',
  cancelReasonLabel: '取消原因：',
  cancelReportConfirmText: '确认取消报备申请吗？<br>一旦取消该设备将无法跨区域激活！',
  cancelReportConfirmTitle: '取消报备申请',
  cancelReportFail: '取消失败',
  cancelReportSuccess: '取消报备成功',
  cancelStartDone: '已取消开始',
  cancelSuccess: '取消成功',
  cannotChangeSubmitted: '当前信息已提交审核，无法更改',
  cannotWithdrawApproved: '学员报名审核已通过，无法撤回',
  caozuo: '操作',
  caseTitleLength: '案例标题：5~20字',
  catalogCategory: '分类目录',
  categoryName: '分类名称',
  categoryNameRequired: '分类名称不能为空',
  changeSuccess: '更改成功！',
  channel: '渠道',
  channelSource: '渠道来源',
  channelSourceStats: '渠道来源统计',
  chargePhone: '负责人电话',
  chuandan: '微传单',
  chuangjian: '创建人',
  ci: '再次邀约',
  cihour: '首次投票时间',
  citeExistingLead: '引用已有线索：',
  citeLeadTip: '您可通过引用"潜在客户"已创建的线索进行绑定并快速完善档案',
  citeLeadTipHtml: '您可通过引用<span style="font-weight: 600;">"潜在客户"</span>已创建的线索进行绑定并快速完善档案',
  claimStudent: '认领学员',
  claimStudentValidityTip: '认领的学员有7天有效期，请尽快处理跟进',
  claimSuccess: '领取成功',
  clickToViewVideo: '点击查看视频',
  clickUpload: '点击上传',
  closeFailed: '关闭失败',
  closeSuccess: '关闭成功',
  closeTitle: '关闭',
  code: '编号',
  collapse: '收起',
  compliant: '合规',
  confirm: '确定',
  confirmAcceptTransfer: '确定接受新学员转入?',
  confirmCancelPublishMaterial: '是否取消发布该资料',
  confirmDeleteImage: '是否确认要删除该图片?',
  confirmDeleteMarker: '确定删除此标记吗？',
  confirmDeleteMaterial: '是否删除该资料，删除后不可恢复',
  confirmDeleteTagType: '确认删除标签类型【{name}】?',
  confirmDeleteTemplate: '确认删除模板',
  confirmOffShelfImage: '是否确认要下架该图片?',
  confirmOffShelfTemplate: '确认下架模板',
  confirmPublishImage: '是否确认要发布该图片?',
  confirmPublishMaterial: '是否发布该资料',
  confirmPublishTemplate: '确认发布模板',
  confirmReceiveCustomers: '确定要领取此{n}条客户吗',
  confirmRejectTransfer: '确定拒绝新学员转入？',
  confirmRestoreCluesTip: '确定要还原这{n}条线索吗？',
  confirmRevokeApply: '确定撤销申报吗？',
  confirmSubmitAudit: '确定提交审核吗？',
  confirmUnmarkPrototype: '确认要取消样机标记？',
  confirmUpdate: '确定更新',
  confirmUpdateTip: '确定要更新吗？',
  considerAgain: '考虑一下',
  consultation: '咨询',
  contactInfo: '联系信息',
  converted: '已转化',
  coordsParentAgentId: '经纬度上级代理商ID',
  coordsPassed: '经纬度通过',
  coordsProvinceCity: '经纬度省市区',
  copy: '复制',
  counterAddress: '柜台地址',
  counterAgentId: '代理商ID',
  counterAgentLabel: '代理商',
  counterAgentName: '代理商名称',
  counterChargePerson: '柜台负责人',
  counterCloseConfirm: '柜台关闭将不可恢复，<br />确定要关闭柜台吗？',
  counterInfoExport: '柜台信息导出',
  counterNo: '柜台编号',
  counterType: '柜台类型',
  course: '课程',
  courseName: '课程名称',
  textbookVersion: '教材版本',
  textfdf6: '教材版本',
  orderRecords: '订单记录',
  invitationRecords: '邀约记录',
  learningReport: '学习报告',
  sailingTrialClass: '启航试听课',
  createBy: '创建人',
  createFail: '创建失败',
  createMaterial: '创建资料',
  createNow: '立即创建',
  createSuccess: '创建成功',
  createTime: '创建时间',
  crossAreaTypeFail: '获取跨区域类型和报备地代理商失败',
  crossRegionNotReported: '跨区未报备',
  crossRegionPendingReview: '跨区未复核',
  crossRegionType: '跨区域类型',
  crossSubjectDeviceTip: '此学员购买的设备并非您同主体经销商名下设备。',
  crossSubjectExhaustTip: '如额度消耗完毕，仍需转入跨主体学员时，将需要省代审核后方能转入，请知晓。',
  crossSubjectLimitExceeded: '您的跨主体设备学员已超出总部允许的最高上限，不可转入。',
  crossSubjectPendingAudit: '已提交申请，请等待审核通过后重试。',
  crossSubjectQuotaTip: '如您需要转入此学员进行督学，将消耗一个跨主体督学额度。',
  crossSubjectRemainLimit: '本月您所在主体的剩余免审核跨主体督学额度：',
  crossSubjectTitle: '跨主体督学',
  crossSubjectUnknown: '跨主体校验结果未知，请稍后重试',
  currentAuthArea: '当前认证区域',
  currentServiceCenterId: '现服务中心ID：',
  currentServiceCenterName: '现服务中心名称：',
  customNameRequired: '名字不能为空',
  customTable: '自定义表格',
  customer: '搜素客户',
  customerChannel: '客户渠道',
  /** 公海领取明细 detailSeaPoolCollection */
  leadsPickTimeRangeLabel: '领取时间范围',
  leadsPickTimeColumn: '领取时间',
  customerName: '客户姓名',
  customerNameLabel: '客户姓名：',
  customerNameLabelShort: '客户姓名',
  customerNameOrPhone: '客户姓名/手机号',
  customerNamePhone: '客户姓名/手机号',
  customerPhone: '客户手机号',
  customerPhoneLabel: '客户手机号',
  dachaxun: '推广大使查询：',
  dailyImage: '每日一图',
  danhao: '快递单号',
  dao: '到访门店',
  dataMigration: '数据迁移',
  dataValidate: '数据校验',
  dataValidateComplete: '数据校验完成,共{total}条学生线索',
  dataValidateError: '数据错误{error}条,请修改后重新尝试',
  dataValidateFail: '数据校验失败',
  logisticsDetailTitle: '物流详情',
  logisticsCompanyName: '公司名称',
  pleaseSelectCompany: '请选择公司',
  latestTag: '最新',
  machineRemarkTitle: '学习机备注',
  remarkLabelShort: '备注',
  remarkPlaceholder: '请输入内容',
  accountRebindTitle: '手机号换绑',
  learningMachineAccountNo: '学习机账户编号',
  learningMachineAccount: '学习机账户',
  learningMachineAccountLabel: '学习机账户：',
  originalMobileLabel: '原手机号',
  newMobileLabel: '新手机号',
  pleaseEnterOriginalMobile: '请填写原手机号',
  pleaseEnterNewMobile: '请填写新手机号',
  verifyCodeLabel: '验证码',
  pleaseEnterVerifyCode: '请输入验证码',
  sendVerifyCode: '发送验证码',
  resendVerifyCode: '重新发送',
  resendAfterSeconds: '{time} 秒后重新发送',
  dataValidateResult: '数据错误{error}条,重复{repeat}条,可导入{pass}条',
  day: '报告日期',
  learningReportDateLabel: '报告日期',
  dealerId: '所属经销商ID',
  dealerInfo: '经销商信息',
  dealerLocation: '经销商所在地',
  dealerName: '所属经销商名称',
  dealerNoQualification: '经销商无服务中心资质，请先报备门店地址。',
  dealerParentAgentId: '经销商上级代理商ID',
  delete: '删除',
  deleteConfirmContent: '删除后，校区将无法继续使用该图片素材，确定删除',
  deleteConfirmDesc: '注意：校区曾使用该图片素材的活动将继续使用，如该素材有风险，需暂停使用，请及时通告各位校长。',
  deleteFailed: '删除失败',
  deleteImage: '删除图片',
  deleteMarker: '删除',
  deleteSuccess: '删除成功',
  detailAddress: '详细地址',
  details: '详情',
  detailLabel: '明细',
  device: '设备型号',
  deviceSN: '设备SN码',
  differentModelCannotMerge: '不同型号或单价的商品不可合并换货',
  dili: '地理',
  dispatchedPrototypeCount: '已发货样机数',
  displayStatus: '显示状态',
  downloadErrorFile: '下载错误文件',
  dragFileHereOr: '将文件拖到此处，或',
  edit: '编辑',
  editExamInfo: '编辑考试信息',
  editFollowRecord: '编辑跟进记录',
  editImage: '编辑图片',
  editInfo: '编辑信息',
  editProfileTitle: '编辑档案',
  editSchoolInfo: '编辑学校信息',
  editSuccess: '编辑成功',
  editTemplate: '编辑',
  effectTime: '生效时间',
  endDate: '结束日期',
  enterExamInfoAtLeastOneYear: '（至少录入一年考试信息）',
  enterExamInfoTitle: '录入考试信息',
  entryAccountCustomerNameOrPhone: '客户姓名/手机号',
  entryAccountExperienceDate: '体验日期',
  entryAccountExperienceEndDate: '体验结束日期',
  entryAccountExperienceStartDate: '体验开始日期',
  entryAccountLearningMachine: '学习机',
  entryAccountOpenPerson: '开通人',
  entryAccountOpenTime: '开通时间',
  entryAccountPleaseEnterSnCode: '请输入学习机SN码',
  entryAccountPleaseSelectStatus: '请选择状态',
  entryAccountSearchCustomer: '搜索客户',
  entryAccountSnCode: '学习机SN码',
  er: '高二',
  eryear: '二年级',
  examInfoTipFeedback: '如搜索不到学校，可通过人工客服反馈申报新学校',
  examProvinceCity: '省市区',
  examStageName: '学段',
  exceed10MLimit: '超过10M限制 不允许上传~',
  exceed20MLimit: '超过20M限制 不允许上传~',
  exceed5MLimit: '超过5M限制 不允许上传~',
  expand: '展开',
  experienceAccountLabel: '体验账号：',
  experienceAccountPasswordLabel: '体验账号密码:',
  experienceAnalystLabel: '体验分析师:',
  experienceAnalyst: '体验分析师',
  experienceDate: '体验日期',
  inviteExperienceDetailAccountLabel: '账号：',
  inviteExperienceDetailPasswordLabel: '密码：',
  inviteExperienceDetailDateLabel: '体验日期：',
  inviteExperienceDetailCourseLabel: '体验课程：',
  inviteExperienceDetailFenyuanLabel: '分析员：',
  experienceDateFormat: 'yyyy 年 MM 月 dd 日',
  experienceEndDate: '体验结束日期',
  experienceInProgress: '体验中',
  experienceQuotaExhausted: '体验额度已用完',
  experienceStartDate: '体验开始日期',
  experienceStartDateLabel: '体验开始日期:',
  experienceSuccess: '体验成功',
  expired: '已过期',
  exportCurrentDetail: '导出当前明细',
  exportDetail: '导出明细',
  exportSuccess: '导出成功',
  fail: '失败',
  familyMember1: '家庭成员1:',
  familyMember1Label: '家庭成员1',
  familyMember1LabelShort: '家庭成员1：',
  familyMember2: '家庭成员2:',
  familyMember2Label: '家庭成员2',
  familyMember2LabelShort: '家庭成员2：',
  contactLabel: '联系人',
  female: '女',
  fen: '40分以上',
  fenlei: '所属分类',
  fenshu: '进步分数',
  fenxiaoyuan: '分销员',
  pleaseSelectDistributor: '请选择分销员',
  fenyuan: '分析员',
  fileAddFail: '文件添加失败',
  fileName: '文件名',
  fileSizeExceed1MB: '上传文件大小不能超过1MB',
  fileSizeExceed5M: '文件大小不能超过5M',
  fillCompleteExamInfo: '请填写完整考试信息',
  fillCreateInfo: '填写创建信息',
  finalScoreCannotExceedTotal: '结课成绩不能大于学科总分',
  finalScoreGtEnrollment: '结课成绩必须大于入学成绩',
  finalScoreLteTotal: '结课成绩不能大于学科总分',
  finishTime: '完成时间',
  finisher: '完成人',
  flyerHeadPic: '传单头图:',
  follow: '跟进人',
  followAction: '跟进',
  followContentRequired: '跟进内容不能为空',
  followDesc: '跟进描述:',
  followFail: '跟进失败',
  followInfo: '跟进信息',
  followLabel: '跟进：',
  followPerson: '跟进人:',
  followPersonLabel: '跟进人:',
  followPersonLabelShort: '跟进人：',
  followPersonRequired: '跟进人不能为空',
  followPersonShort: '跟进人',
  followRecord: '跟进记录',
  followRemindTitle: '跟进提醒',
  followStatusColumn: '跟进状态',
  followStatusLabel: '跟进状态:',
  followStatusShort: '跟进状态',
  followSuccess: '跟进成功',
  followType: '跟进类型:',
  followUp: '跟进',
  followUpSuccess: '跟进成功',
  /** 跟进管理列表-累计跟进列（避免与通用 follow 跟进人冲突） */
  followUpMgmt_totalFollow: '累计跟进',
  followVoucher: '跟进凭证',
  followVoucherLabel: '跟进凭证:',
  frozen: '冻结',
  fulltimeLabel: '全日制',
  galleryTypeColon: '类型：',
  genderLabel: '性别：',
  gender: '性别',
  getRecycleCountFail: '获取即将回收数量失败',
  getTemplateInfoFail: '获取模板信息失败',
  getTodayCountFailed: '获取今日可领取数量失败',
  goToPerfect: '去完善',
  gotIt: '我知道了',
  grade: '阶段年级',
  gradeText: '年级',
  gradeLabel: '年级:',
  gradeLabelColon: '年级:',
  gradeLabelShort: '年级：',
  gradeRequired: '年级不能为空',
  grantFail: '发放失败',
  grantPass: '发放通行证',
  grantPassTitle: '发放通行证',
  grantReasonLabel: '发放原因：',
  grantSuccess: '发放成功',
  growthReport: '成长报告',
  handleLater: '稍后处理',
  hantianOutcall: '汉天外呼',
  hao: '开通入门账号',
  haohour: '号时填写',
  homeAddress: '家庭住址:',
  homeAddressLabel: '家庭住址：',
  hour: '报告开始时间',
  houryici: '这时候直接用上一次的参数',
  howToGetMore: '如何获取更多例子？',
  hua: '通话录音',
  huashi: '通话时长',
  identity: '身份:',
  imageAddFailed: '图片添加失败',
  imageDelete: '图片删除',
  imageDeleteFail: '图片删除失败',
  imageDeleteSuccess: '图片删除成功',
  imageExceed5M: '图片大于5M，请压缩后上传!',
  imageFormatJpgJpegPng: '只能上传JPG、JPEG、PNG格式的图片',
  imageFormatJpgPng: '图片支持jpg/png格式!',
  imageFormatJpgPngGif: '图片只能是 JPG/PNG/GIF 格式!',
  imageFormatOnlyJpgPng: '只能上传JPG 、PNG格式的图片~',
  imageFormatTip: '支持jpg/png格式',
  imageMaterial: '图片资料',
  imageMax6Count: '上传的图片不能超过6张~',
  imageMax9Count: '上传的图片不能超过9张~',
  imageNoDuplicate: '禁止上传重复图片~',
  imageOffShelf: '图片下架',
  imagePublish: '图片发布',
  imageSizeExceed10M: '超过10M限制 不允许上传~',
  imageSizeExceeded: '上传图片大小不能超过 20MB!',
  imageSizeTip: '*建议图片宽度:1080 X 600，点击图片可进行信息提示标记',
  importComplete: '导入完成',
  importCountTip: '数据仅统计新增线索',
  importDetail: '导入详情',
  importErrorTip: '部分数据错误，若确认导入，错误数据不会导入到系统',
  importErrorTitle: '警告：仍有数据错误',
  importQuery: '导入查询',
  importTime: '导入时间',
  importedCount: '已导入',
  inactive: '未激活',
  infoNotExist: '信息不存在',
  insertText: '插入文字',
  intentLevel: '意向级别:',
  intentLevelColumn: '意向级别',
  intentLevelChangeSuccess: '意向程度改变成功',
  intentLevelLabel: '意向程度:',
  intentLevelLabelColon: '意向程度:',
  intentionHigh: '高',
  intentionMedium: '中',
  intentionLow: '低',
  intentLevelText: '意向级别',
  invalidReason: '失效原因',
  invalidVideoDuration: '视频时长不符合要求',
  invalidVideoFormat: '上传视频格式不正确',
  inviteBigExam: '邀约大体检',
  texttyhq: '邀约大体检',
  textt3r7: '最新发布',
  textxdis: '学员作业',
  textaqxc: '再次邀约',
  textl0nm: '更多',
  text9bhv: '成长报告',
  textaq54: '标注成功',
  text6sid: '标记失效',
  text5uk0: '取消',
  textnfjg: '确定',
  texththy: '查看报告',
  text4pq7: '查看答题记录',
  texth0qa: '点击上传',
  textf3rq: '邀约成功！',
  text7tna: '复制',
  inviteFailed: '邀约失败',
  inviteKnowledgeVulnExam: '邀约知识漏洞大体检',
  inviteKnowledgeVulnExamSuccess: '知识漏洞大体检邀约成功！',
  inviteKnowledgeVulnExamTime: '邀约知识漏洞大体检时间',
  inviteLocation: '邀约地点',
  inviteDetail: '邀约详情',
  invitePhysicalExamTime: '邀约知识漏洞大体检时间',
  inviteRewardTier2MoreThanTier1: '邀请奖励第2阶梯邀请人数需要比第1阶梯人数多',
  inviteRewardTier3MoreThanTier2: '邀请奖励第3阶梯邀请人数需要比第2阶梯人数多',
  inviteStudentTransfer: '邀请学员转入',
  inviteSuccess: '邀约成功',
  inviteSuccessExclaim: '邀约成功！',
  inviteSuccessTip: '知识漏洞大体检邀约成功！',
  inviteSuccessTitle: '邀约知识漏洞大体检',
  inviteTime: '邀约时间',
  inviteTransfer: '邀请转入',
  inviteTransferShort: '邀请转入',
  inviteType: '邀约类型:',
  inviter: '跟进人',
  ip: 'IP',
  isMultiSelect: '是否多选',
  isMultiSelectColumn: '是否可多选',
  isReported: '是否报备',
  itemsUnit: '项',
  ji: '意向级别',
  jie: '冻结',
  jiuyear: '九年级',
  juniorHigh: '初中',
  kexue: '科学',
  labelColon: '标签：',
  lastCommunicateTime: '最近跟进时间',
  lastFollowTime: '最后跟进时间',
  lastUpdateTime: '末次修改时间',
  lastUpdateUser: '最后更新人',
  latitude: '纬度',
  leadAssignTime: '线索分配时间',
  leadCreateTime: '线索创建时间',
  leadDetailTitle: '线索详情',
  leadIdentity: '线索身份:',
  leadInfo: '线索信息',
  leadInfoSettingsLabel: '留咨信息设置',
  shareRuleSettingsLabel: '分享规则设置',
  leadMarkFailedSelectReason: '线索标记失败，需选择失效原因',
  leadName: '线索姓名:',
  leadNameColumn: '线索姓名',
  leadNameLabel: '线索姓名:',
  leadNameRequired: '线索姓名不能为空',
  leadPhone: '线索手机号:',
  leadPhoneAutoMatch: '已根据您填写的线索手机号为您自动匹配用户信息',
  leadPhoneLabel: '线索手机号:',
  leadRatio: '线索占比',
  leadSourceLabel: '线索来源：',
  learnCenterAccount: '学习中心账号',
  learningCenterAccount: '学习中心账号',
  learningMachine: '学习机',
  learningMachineAccountNo: '学习机账户编号',
  learningMachineSn: '学习机SN码',
  li: '物理',
  liang: '收藏量',
  liuyear: '六年级',
  loadFailed: '加载失败',
  loadSearchResultFail: '加载搜索结果失败，请稍后重试！',
  location: '所在地',
  locationSource: '定位来源',
  longTermTempPass: '长期临时通行证',
  longitude: '经度',
  ma: 'SN码',
  machine: '学习机账户',
  machineAccount: '学习机账户',
  machineAccountLabel: '学习机账户 ：',
  machineConversionNum: '学习机转化数',
  machineConversionRate: '学习机转化率',
  machineConversionRatio: '学习机转化占比',
  machineManageAccount: '学习机管理账户',
  machineSNCodeLabel: '学习机SN码：',
  male: '男',
  markAsCase: '标记为案例',
  markFailedSuccess: '标记失效成功',
  markInvalid: '标记失效',
  leadInvalidConfirmTip: '线索失效后将被记为无效数据，不再线索列表中展示，请确认是否继续标记失效？',
  markInvalidFail: '标记失效失败',
  markInvalidSuccess: '标记失效成功',
  markPrototype: '标记样机',
  markSuccess: '标记成功',
  markSupervisorInfo: '标记督学信息',
  markSupervisorStatusBtn: '标记督学状态(原分配服务人员)',
  markSupervisorStatusTooltip: '标记学员督学方式后，分析师端可通过筛选，比对不同督学状态下学员学情。',
  markSupervisorTooltipExpired: '督学到期：标记督学有效期后，督学结束时间系统自动变更学员督学状态。',
  markSupervisorTooltipExpiring: '督学即将到期：离督学结束时间只剩14天',
  markSupervisorTooltipNone: '无督学：服务中心当前未提供督学服务。',
  markSupervisorTooltipOnlineOnly: '仅线上：未报名自习室，分析师在线上提供督学服务。',
  markSupervisorTooltipStudyRoom: '自习室：学员已报名线下自习室。',
  markSupervisorTooltipUnmarked: '未标记：当前暂无督学状态，等待分析师标记',
  markedPrototypeCount: '商品标记样机数品型号',
  markerPositionExists: '当前位置已有标记，请重新选择',
  materialInterpretation: '资料解读',
  materialInterpretationPlaceholder: '输入该资料的解读，限制最大字数500字',
  materialPreview: '资料预览',
  materialSort: '资料排序',
  max20Chars: '不得超过20个汉字（及等同数量字符）',
  max28Chars: '不得超过28个汉字（及等同数量字符）',
  max50Chars: '不得超过50个汉字（及等同数量字符）',
  max5FilesUpload: '最多只能上传5个（图片或PDF）文件',
  maxTwoExamScores: '最多选择两个考试成绩',
  microFlyer: '微传单',
  microVideo: '微视频',
  min: '表单顶部分类格式',
  minhour: '课程分配时间',
  minmin: '上面是分页器部分',
  minutesUnit: '分钟',
  mobile: '手机号',
  mobileLabel: '手机号',
  modifySuccess: '修改成功',
  month: '月同比',
  monthRemainLimit: '本月剩余可发放：',
  monthlyRemainLimitTip: '本月剩余体验额度：{remain}，本次邀约消耗1个额度',
  moreActions: '更多操作',
  my: '我的',
  myLeads: '我的线索',
  myServiceLoadFail: '我的客服加载失败',
  name: '名称',
  nameColon: '名称：',
  nameLabel: '姓名',
  nameRequired: '名字不能为空',
  newActivated: '新激活',
  newLead: '新增线索',
  newPhone: '新手机号',
  nextCommunicateTime: '下次跟进时间',
  nextFollowTime: '下次跟进时间:',
  nextStep: '下一步',
  no: '否',
  noFollowNeeded: '无需跟进',
  noGrayscale: '无灰度',
  noLimit: '不限',
  noMoreShareTarget: '暂无更多分摊对象',
  shareTarget: '分摊对象',
  shareTargetNotSpecified: '您还未指定分摊对象',
  noPass: '未持有',
  noProvinceCrossRegion: '无省市区代跨区',
  noRelatedInfoFound: '没有找到相关信息',
  noSuitableReasonTip: '若无合适的原因，您可在规则设置-失效原因中设置',
  noTransferApply: '当前无学员转入申请',
  noValidUploadData: '没有一条符合上传的数据',
  noVirtualPhoneForLead: '不可使用虚拟手机号创建线索',
  nonCompliant: '不合规',
  none: '无',
  notFilled: '未填写',
  notFilledFollowContent: '还未填写跟进内容',
  notSure: '我不清楚',
  offShelf: '下架',
  offShelfSuccess: '下架成功',
  onShelf: '上架',
  onlyOneFile: '只能上传一个文件',
  onlyXlsFormat: '仅支持.xls格式的文件',
  onlyXlsXlsxFormat: '仅支持xls/xlsx格式的文件',
  openEntryAccount: '开通入门账号',
  entryQuotaLabel: '入门账号额度：',
  entryOpenCustomerLabel: '开通客户：',
  entryCustomerPlaceholder: '请输入手机号或姓名',
  entryNoCustomerFound: '没有查询到客户',
  entryExperienceValidityLabel: '体验有效期：',
  entryLearningMachineLabel: '学习机：',
  entryMachinePlaceholder: '学习机型号或SN码',
  entryNoMachineFound: '没有查询到学习机',
  entryOpenSuccessTitle: '入门账号开通成功',
  entryCustomerNameLabel: '客户姓名',
  entryCustomerAccountLabel: '客户账号',
  entryPasswordLabel: '密码',
  entryExperienceDateLabel: '体验日期',
  openExperience: '开通体验',
  openExperienceAccount: '开通体验账号',
  openTime: '开通时间',
  openExperienceAccountSuccess: '开通体验账号成功',
  openExperienceFailed: '开通体验失败',
  openService: '开通服务',
  operateTime: '操作时间',
  operation: '操作',
  operationColumn: '操作',
  operationFail: '操作失败',
  operationFailed: '操作失败，请稍后重试',
  operationModeLabel: '运营方式：',
  operationSuccess: '操作成功',
  operationType: '操作类型',
  operationTypeImport: '导入',
  operationTypeTip1: '当上传文档后系统仅新增了线索，则操作类型为导入。',
  operationRecord: '记录',
  operationTypeTip2: '当上传文档后系统仅更新了线索，则操作类型为更新。',
  operationTypeUpdate: '更新',
  operator: '操作人',
  optional: '选填',
  orderName: '订单名称',
  orderNo: '订单编号',
  orderPayAmount: '下单金额',
  orderPayUser: '下单人',
  orderStatus: '订单状态',
  orderTime: '下单时间',
  orderType: '订单类型',
  addOrderRecord: '添加订单记录',
  dealDetail: '成单详情',
  addOrder: '添加订单',
  editOrder: '编辑订单',
  learningMachineNewSign: '学习机新签',
  supervisionNewSign: '督学新签',
  supervisionRenew: '督学续费',
  learningMachineInfo: '学习机信息',
  pleaseEnterManagerMobileOrSn: '请输入管理账号手机号或SN码',
  operationTip: '操作提示',
  confirmDeleteOrder: '确认删除订单吗',
  originalPhone: '原手机号',
  other: '其他',
  otherInfo: '其他信息',
  outboundExpiredCannotRenew: '您当前不在服务有效期内，不能续费。请重新开通服务',
  outboundNotOpened: '您尚未开通外呼服务，请在开通后再充值',
  outboundOpening: '您的外呼服务正在开通中，预计下单后7个工作日内可完成，请在开通后再充值',
  ownerTime: '分配时间',
  ownerTimeLabel: '分配时间',
  packageRemainingMinutes: '套餐剩余分钟',
  parentAgentId: '上级代理商ID',
  parentAgentName: '上级代理商名称',
  participationExportFilename: '参与情况导出{time}.xls',
  participationPageTitle: '活动参与情况',
  passHolding: '通关证持有中',
  passStatusLabel: '通行证状态 ：',
  passStatusColumn: '通行证状态',
  passStatusTable: '通行证状态',
  passportStatus: '通行证状态',
  passportStatusNone: '未持有',
  passportStatusPass: '通关证持有中',
  passportStatusTemp: '临时通行证持有中',
  passwordLabel: '密码',
  paySettings: '支付设置',
  paymentFail: '付款失败',
  pending: '待发布',
  pendingAllocate: '待分配',
  pendingFollow: '待跟进',
  pendingPublish: '待发布',
  inProgress: '活动中',
  paused: '暂停中',
  ended: '活动结束',
  wechatScanPreview: '微信扫一扫预览',
  downloadActivityQRCode: '下载活动二维码',
  downloadQrCode: '下载二维码',
  pauseActivity: '暂停活动',
  pause: '暂停',
  startActivity: '开始活动',
  start: '启动',
  activityPreview: '活动预览',
  activityParticipationDetail: '活动参与详情',
  activityEdit: '活动编辑',
  publishActivityTip: '发布后学员即可查看并参与活动，确认发布？',
  publishActivityTitle: '发布活动',
  publishSuccessTip: '您可下载活动二维码进行推广，或在活动列表中查看参与详情。',
  publishSuccessTitle: '活动发布成功',
  confirmDeleteActivityTip: '确认删除活动？',
  activityDeleteTitle: '活动删除',
  confirmPauseActivityTip: '确认暂停活动？',
  confirmActivityToggleTip: '确定要{action}该活动吗？',
  pauseActivityTitle: '暂停活动',
  confirmStartActivityTip: '确认开始活动？',
  startActivityTitle: '开始活动',
  perfectSuccess: '完善成功',
  perfectUserProfile: '完善用户档案',
  person: '人员',
  phoneBillBalance: '话费余额',
  phoneLabel: '手机号:',
  phoneNotVerified: '客户手机号未进行验证。',
  picture: '图片',
  planTime: '计划时间',
  pleaseAddRepairDetail: '请添加维修明细',
  pleaseAddStudentStory: '请添加学员故事',
  pleaseCheckOutboundProtocol: '请先阅读并勾选外呼服务的服务协议',
  pleaseCompleteUserProfile: '请先完善用户档案',
  pleaseEditStudentScore: '请编辑学习成绩',
  pleaseEnter: '请输入活动ID',
  pleaseEnter4DigitCode: '请输入四位数字验证码',
  pleaseEnterActivityDesc: '请输入活动描述',
  pleaseEnterActivityName: '请输入活动名称',
  pleaseEnterActivityPrize: '请输入活动奖品',
  pleaseEnterActivityRules: '请输入活动规则',
  pleaseEnterActivityTag: '请输入活动标签',
  pleaseEnterActivityTitle: '请输入活动标题',
  pleaseEnterAdapAccount: '请输入智适应账号',
  pleaseEnterAgencyAddress: '请输入机构地址',
  pleaseEnterAgencyContact: '请输入机构联系人',
  pleaseEnterAgencyIntro: '请输入机构简介',
  pleaseEnterAgencyName: '请输入机构名称',
  pleaseEnterApplyReason: '请填写申请原因',
  pleaseEnterApplySuccessMsg: '请输入报名成功提示语',
  pleaseEnterApplySuccessReminder: '请输入报名成功提醒',
  pleaseEnterBriefIntro: '请输入简要介绍',
  pleaseEnterButtonName: '请输入按钮名称',
  pleaseEnterCancelReason: '请输入取消原因',
  pleaseEnterCaseTitle: '请输入案例标题',
  campusCaseCreatorLabel: '学员所在地',
  campusCaseCreatorPlaceholder: '请选择省市',
  campusCaseLabelSubject: '学习科目：',
  campusCaseLabelProgressScore: '进步成绩：',
  campusCaseLabelEnrolScore: '入学成绩：',
  campusCaseSortTitleWithColon: '排序：',
  campusCaseFilterResultBefore: '当前筛选结果为',
  campusCaseFilterResultAfter: '条',
  campusCaseFilterCollapse: '收起选项',
  campusCaseFilterMore: '更多选项',
  pleaseEnterCatalogName: '请输入分类目录的名称',
  pleaseEnterCatalogSort: '请输入分类目录排序',
  pleaseEnterCategoryName: '请输入非空分类名称',
  pleaseEnterClassFrequency: '请输入上课频率',
  pleaseEnterClassNum: '请输入上课节数',
  pleaseEnterContact: '请输入联系人',
  pleaseEnterContactMethod: '请输入联系方式',
  pleaseEnterContactNumber: '请输入供助力用户联系的号码',
  pleaseEnterContent: '请输入内容',
  pleaseEnterCorrectAmount: '请输入正确的金额',
  pleaseEnterCorrectCustomerInfo: '请输入正确开通客户信息',
  pleaseEnterCorrectMachineInfo: '请输入正确学习机信息',
  learningMachineInfoInvalid: '您上传的学习机信息不正确',
  pleaseEnterCorrectPeriod: '请输入正确的期数',
  pleaseEnterCorrectPhone: '请输入正确的手机号',
  pleaseEnterCorrectSN: '请填写正确的SN码',
  pleaseEnterCounterAddress: '请输入柜台地址',
  pleaseEnterCounterManagerName: '请输入柜台负责人姓名',
  pleaseEnterCounterManagerPhone: '请输入柜台负责人电话',
  pleaseEnterDescription: '请输入描述',
  pleaseEnterDetailAddress: '请输入详细地址',
  pleaseEnterDeviceSN: '请输入设备SN码',
  pleaseEnterEnrollmentScore: '请输入入学成绩',
  pleaseEnterFamilyMember1Phone: '请输入家庭成员1的线索手机号',
  pleaseEnterFamilyMember2Phone: '请输入家庭成员2的线索手机号',
  pleaseEnterFamilyMemberPhone: '请输入家庭成员{n}的线索手机号',
  pleaseEnterFinalScore: '请输入结课成绩',
  pleaseEnterFollowContent: '请输入跟进内容',
  pleaseEnterFollowType: '请输入跟进类型',
  pleaseEnterFullMarks: '请输入满分',
  pleaseEnterHandwrittenEssay: '请输入亲笔短文',
  pleaseEnterHomeAddress: '请输入家庭住址',
  pleaseEnterImageName: '请输入图片名字',
  pleaseEnterInviteLocation: '请输入邀约地点',
  pleaseEnterLapseReason: '请输入失效原因名称',
  pleaseEnterLeadName: '请输入线索姓名',
  pleaseEnterLeadNameOrPhone: '请输入潜在客户的姓名或者手机号',
  pleaseEnterLearningMachineInfo: '请输入学习机信息',
  pleaseEnterLearningMachineSn: '请输入学习机SN码',
  pleaseEnterLeftTitle: '请输入左侧标题',
  pleaseEnterLegalName: '请输入合法姓名',
  pleaseEnterMachineAccount: '请输入学习机账户',
  pleaseEnterSNCode: '请输入SN码',
  materialNameLabel: '资料名称',
  pleaseEnterMaterialName: '请输入资料名称',
  pleaseEnterMaterialSort: '请输入资料排序',
  pleaseEnterMonthNum: '请先输入开通月数',
  pleaseEnterName: '请输入名称',
  pleaseEnterNameOrPhone: '请输入姓名/手机号',
  pleaseEnterNamePlaceholder: '请输入{type}名称',
  pleaseEnterNameRule: '请输入汉字、数字、字母、下划线或圆点',
  pleaseEnterNewPhone: '请填写新手机号',
  pleaseEnterNewStudentName: '请填写新学员姓名',
  pleaseEnterNotice: '请输入公告',
  pleaseEnterOriginalPhone: '请填写原手机号',
  pleaseEnterPageDesc: '请输入页面描述',
  pleaseEnterPageName: '请输入页面名称',
  pleaseEnterPassword: '请输入密码',
  pleaseEnterPhone: '请输入手机号',
  pleaseEnterPhoneFirst: '请先输入手机号',
  pleaseEnterPromoterName: '请输入推广大使姓名',
  pleaseEnterQrCodeIntro: '请输入机二维码介绍',
  pleaseEnterReason: '请输入原因',
  pleaseEnterReason5to100: '请输入原因（5-100字）',
  pleaseEnterReceiverPhone: '请输入收货人电话',
  pleaseEnterRegistrationInfo: '请输入报名信息',
  pleaseEnterRejectReason: '请输入拒绝原因',
  pleaseEnterRemarkPlaceholder: '请输入备注',
  pleaseEnterReportReason: '请输入报备原因',
  pleaseEnterSN: '请输入SN码',
  pleaseEnterSNOrTimeToExport: '请输入SN码或选择创建时间，再导出',
  pleaseEnterSchoolName: '请输入学校名称',
  pleaseEnterScore: '请输入成绩',
  pleaseEnterServiceCenterName: '请输入服务中心名称',
  pleaseEnterShipAddress: '请输入发货地址',
  pleaseEnterSourceName: '请输入来源名称',
  pleaseEnterStoreName: '请输入店铺名称',
  pleaseEnterStudentAccountFirst: '请先输入学员账号',
  pleaseEnterStudentAccountOrName: '请输入学员账号、学员姓名',
  pleaseEnterStudentNameOrPhone: '请输入学员姓名/手机号',
  pleaseEnterStudentName: '请输入学员姓名',
  pleaseEnterStudentPhone: '请输入学员手机号',
  pleaseEnterStudentScoreInfo: '请录入学员成绩信息',
  pleaseEnterSubjectTotalScore: '请输入学科总分',
  pleaseEnterSupervisorFee: '请输入督学费用',
  pleaseEnterTagName: '请输入标签名称',
  pleaseEnterTagNamePlaceholder: '请输入标签名称',
  pleaseEnterTemplateName: '请输入活动模板名称',
  pleaseEnterTemplateNameSearch: '请输入模板名称',
  pleaseEnterTitle: '请输入标题',
  pleaseEnterUser: '请输入用户',
  pleaseEnterValidAdaptiveAccount: '请输入有效的智适应账号',
  pleaseEnterValidContactNumber: '请输入有效的联系号码',
  pleaseEnterValidNumber: '请输入有效数字',
  pleaseEnterValidPhone: '请输入有效手机号',
  pleaseEnterValidPhoneNum: '请输入有效手机号',
  pleaseEnterValidRechargeAmount: '请先输入有效的话费金额',
  pleaseEnterVerifyAddress: '请输入体验卡核销地址',
  pleaseEnterVerifyCode: '请输入验证码',
  pleaseEnterWeeklyFoundationHours: '请输入每周打地基时长',
  pleaseFill2_50Chars: '请填写2-50字',
  pleaseFillActivityDesc: '请填写活动说明',
  pleaseFillActivityName: '请填写活动名称',
  pleaseFillActivityRules: '请填写活动规则',
  pleaseFillActivityTitle: '请填写活动标题',
  pleaseFillAdaptiveAccount: '请补充智适应账号',
  pleaseFillAdaptiveAccountShort: '请补充完整智适应账号',
  pleaseFillAgencyAddress: '请填写机构联系地址',
  pleaseFillAgencyContact: '请填写机构联系电话',
  pleaseFillAgencyIntro: '请填写机构介绍',
  pleaseFillCaseSettingsFirst: '请先填写案例设置',
  pleaseFillFollowContent: '请填写跟进内容',
  pleaseFillInviteRewardRule: '请填写完邀请奖励的第1阶梯的活动规则',
  pleaseFillMarkerContent: '请填写标记内容',
  pleaseFillProgressPlan: '请填写进步方案',
  pleaseFillRemarkFirst: '请先填写备注',
  pleaseFillShareRatio: '请填写{name}的分摊比例',
  pleaseEnterShareRatio: '请输入分摊比例',
  pleaseFillStoreRewardRule: '请填写完到店奖励第1阶梯的活动规则',
  pleasePerfectUserProfile: '请先完善用户档案',
  pleasePerfectUserProfileFor: '请先完善{name}的用户档案',
  pleasePerfectUserProfileSimple: '请完善用户档案',
  pleaseSearchAccount: '请搜索账号',
  pleaseSelect: '请选择',
  pleaseSelectAccountStatus: '请选择账户状态',
  pleaseSelectActivityEndTime: '请选择活动结束时间',
  pleaseSelectActivityFollower: '请选择活动跟进人',
  pleaseSelectActivityStartTime: '请选择活动开始时间',
  pleaseSelectActivityTime: '请选择活动时间',
  pleaseSelectAgent: '请选择代理商',
  pleaseSelectAgentFirst: '请先选择要分配的代理商',
  pleaseSelectAnalyst: '请选择分析师',
  pleaseSelectAppointmentTime: '请选择预约时间',
  pleaseSelectAssignAnalyst: '请选择分配分析师',
  pleaseSelectAssignPerson: '请选择分配人员',
  pleaseSelectBgColor: '请选择背景色',
  pleaseSelectBirthDate: '请选择出生日期',
  pleaseSelectBusinessStatus: '请选择营业状态',
  pleaseSelectCallStatus: '请选择话务沟通状态',
  pleaseSelectCatalog: '请选择分类目录',
  pleaseSelectChangeReason: '请选择变更原因',
  pleaseSelectChannel: '请选择渠道',
  pleaseSelectCounterType: '请选择柜台类型',
  pleaseSelectCrossRegionType: '请选择跨区域类型',
  pleaseSelectCustomerChannel: '请选择客户渠道',
  pleaseSelectDate: '请选择日期',
  pleaseSelectDeviceToSelected: '请选择设备到已选区！',
  pleaseSelectDisplayStatus: '请选择显示状态',
  pleaseSelectDoubleOrder: '请选择是否开通双重订单',
  pleaseSelectEnrollmentGrade: '请选择入学年级',
  pleaseSelectExamDate: '请选择考试日期',
  pleaseSelectExamType: '请选择考试类型',
  pleaseSelectExchangeIn: '请选择换入商品',
  pleaseSelectExchangeOut: '请选择换出商品',
  pleaseSelectExperienceAnalyst: '请选择体验分析师',
  pleaseSelectExperienceDate: '请选择体验日期',
  pleaseSelectFamilyMemberRelation: '请选择家庭成员{n}的关系',
  pleaseSelectFileType: '请选择文件类型',
  pleaseSelectFirstLevelTag: '请选择一级标签',
  pleaseSelectFollowPerson: '请选择跟进人',
  pleaseSelectFollowStatus: '请选择跟进状态',
  pleaseSelectFollowType: '请选择跟进类型',
  pleaseSelectFollower: '请选择跟进人',
  pleaseSelectGradeFirst: '请先选择年级',
  pleaseSelectIdentityType: '请选择身份类型',
  pleaseSelectIntentLevel: '请选择意向级别',
  pleaseSelectInvalidReason: '请选择失效原因',
  pleaseSelectInviteDate: '请选择邀约日期',
  pleaseSelectInviteType: '请选择邀约类型',
  /** 邀约管理-知识漏洞大体检-邀约成功弹窗（专用，勿与 auto_499 等混用） */
  inviteBigExamSuccessDialogTitle: '知识漏洞大体检',
  inviteBigExamSuccessTopic: '知识漏洞大体检邀约成功！',
  inviteBigExamAppointmentTimeLabel: '邀约知识漏洞大体检时间',
  inviteBigExamKnow: '知道了',
  pleaseSelectInviter: '请选择跟进人',
  pleaseSelectIsMultiSelect: '请选择是否多选',
  pleaseSelectLabel: '请选择标签',
  pleaseSelectLocation: '请选择所在地',
  pleaseSelectOperationMode: '请选择运营方式',
  pleaseSelectOperator: '请选择操作人',
  pleaseSelectOrderSplitType: '请选择订单分摊类型',
  orderSplitType: '订单分摊',
  independentComplete: '独立完成',
  collaborationSplit: '协作分摊',
  pleaseSelectOrderStatus: '请选择订单状态',
  pleaseSelectOrderType: '请选择订单类型',
  pleaseSelectPageCategory: '请选择页面分类',
  pleaseSelectPassStatus: '请选择通行证状态',
  pleaseSelectPerson: '请选择人员',
  pleaseSelectPrincipal: '请选择负责人',
  pleaseSelectPrototypeType: '请选择样机类型',
  pleaseSelectProvinceCity: '请选择省市',
  pleaseSelectQuota: '请选择本期名额',
  pleaseSelectRankTime: '请选择上榜时间',
  pleaseSelectRealNameStatus: '请选择认证实名人脸',
  pleaseSelectRecycleReason: '请选择回收原因',
  pleaseSelectRegistrationInfo: '请选择报名信息设置',
  pleaseSelectReportActivateArea: '请选择报备激活地',
  pleaseSelectReviewResult: '请选择复核结果',
  pleaseSelectScheduleDate: '请选择预约日期',
  pleaseSelectScheduleTime: '请选择预约时间',
  pleaseSelectSchool: '请选择学校',
  pleaseSelectServicePerson: '请选择服务人员',
  pleaseSelectShipStatus: '请选择发货状态',
  pleaseSelectShipWarehouse: '请选择发货仓库',
  pleaseSelectSigningParty: '请选择签约主体',
  pleaseSelectSoftwareActiveStatus: '请选择软件激活状态',
  pleaseSelectSource: '请选择来源',
  pleaseSelectStage: '请选择阶段',
  pleaseSelectStageExam: '请选择学段',
  pleaseSelectStageFirst: '请先选择阶段',
  pleaseSelectStageGrade: '请选择阶段年级',
  pleaseSelectStartEndTime: '请选择开始结束时间',
  pleaseSelectStatus: '请选择状态',
  pleaseSelectStudent: '请选择学员',
  pleaseSelectStudentFirst: '请选择学员',
  pleaseSelectStudentToClaim: '请先选择待领取的学员',
  pleaseSelectStudyTime: '请选择学习时间',
  pleaseSelectSubTag: '请选择子标签',
  pleaseSelectSubject: '请选择学习科目',
  pleaseSelectSyncCourseStatus: '请选择同步课状态',
  pleaseSelectTag: '请选择标签',
  pleaseSelectTagType: '请选择标签类型',
  pleaseSelectTemplateStatus: '请选择模板状态',
  pleaseSelectTemplateType: '请选择活动模板类型',
  pleaseSelectTestConfirmTime: '请选择测试确认时间',
  pleaseSelectTestStatus: '请选择测试状态',
  pleaseSelectVisitStore: '请选择到访门店',
  pleaseSelectYear: '请选择录入的年度',
  pleaseSetActivitySpecifiedTime: '请设置活动的指定时间',
  pleaseSetActivityTime: '请设置活动时间',
  pleaseSetQueryFirst: '请先设置查询条件',
  pleaseStartOutboundFirst: '请点击右上角"开始外呼"后进行外呼～',
  pleaseUploadAgreement: '请上传协议后保存！',
  pleaseUploadFaultImage: '请上传故障图片',
  pleaseUploadFile: '请上传文件',
  pleaseUploadFileImagePdf: '请上传文件，支持图片或PDF',
  pleaseUploadFirstDiagnosisMedia: '请上传初诊图片/视频',
  pleaseUploadImage: '请上传图片',
  pleaseUploadImageFormat: '图片上传格式不正确，请上传 jpg/png/jpeg 格式的图片',
  pleaseUploadInspectionMedia: '请上传质检图片/视频',
  pleaseUploadMaterial: '请上传资料',
  pleaseUploadParentFeedback: '请上传家长反馈',
  pleaseUploadVideo: '请上传视频',
  pleaseUploadVideoFormat: '请上传 mp4/mov 格式的视频文件',
  pleaseVerifyDeviceSn: '请先验证设备SN码',
  preview: '预览',
  previewImage: '预览图片',
  previewTemplateTitle: '营销活动模板预览',
  previewTitle: '预览',
  primarySchool: '小学',
  productName: '商品名称',
  pleaseEnterProductName: '请输入商品名称',
  profileComplete: '已完善',
  profileIncomplete: '未完善',
  progressOperator: '操作人',
  promisedVisitTime: '诺访时间:',
  promisedVisitTip: '客户承诺到访门店的时间',
  promoteCount: '推广台数',
  promoterQuery: '推广大使查询：',
  prototypeNote1: '1、学习机一旦标记为样机，将不可修改；',
  prototypeNote2: '2、样机不可用于销售，仅作体验和展示用途；',
  prototypeNote3: '3、每台样机只能绑定一个学习账号，已绑定多个学习账号的',
  prototypeNote3Sub: '设备标记为样机，必须选择保留的账号，其他账号将与学习机解绑；',
  prototypeNoteLabel: '注:',
  prototypeProductModelLabel: '商品型号:',
  prototypeSNCode: '样机SN码',
  prototypeDeviceSNLabel: '设备SN码:',
  prototypePleaseEnterDeviceSN: '请输入设备SN码',
  prototypeTypeLabel: '样机类型:',
  prototypePleaseSelectType: '请选择样机类型',
  prototypeDispatchedCountLabel: '已发货样机数:',
  prototypeMarkedCountLabel: '商品标记样机数品型号:',
  prototypeAvailableCountLabel: '可标记样机数:',
  prototypeRenewal: '样机账户续期',
  prototypeRenewalApply: '样机账户续期申请',
  prototypeType: '样机类型',
  provinceCity: '所在省市区',
  provinceCityLabel: '省市区：',
  publicPool: '公有池',
  publicSchoolStage: '公校学段',
  publish: '发布',
  publishFailed: '发布失败',
  publishSuccess: '发布成功',
  published: '已发布',
  purchaseSuccess: '购买成功',
  qi: '缓冲期',
  qiyear: '七年级',
  qrcodeGenerateFail: '二维码生成失败，请重试',
  qu: '领取人',
  queryFailed: '查询失败',
  queryFollowRemindFail: '查询跟进提醒失败',
  queryLearningTrackFail: '查询学员学习轨迹失败',
  queryProgressScoreFail: '查询进步分数失败',
  queryScoreFail: '查询成绩失败',
  querySuccess: '查询成功',
  quickFilter: '快捷筛选:',
  ququ: '跨区域活跃省市区',
  reUpload: '重新上传',
  realNameStatusLabel: '是否认证实名人脸',
  realNameStatusTable: '是否认证实名人脸',
  reason: '原因',
  recallConfirmTip: '当前您已选中{n}条线索，完成收回操作后，该部分线索将变为无人跟进的待分配状态，请确认是否继续收回操作',
  recallReminder: '收回提醒',
  receive: '领取',
  receiveFailed: '领取失败',
  receiveSuccess: '领取成功',
  rechargePhoneBill: '充值话费',
  recycleBin: '回收站',
  recycleReason: '回收原因',
  recycleTime: '回收时间',
  recycleTimeRange: '回收时间范围：',
  registerTime: '注册时间',
  reject: '拒绝',
  rejectReasonLabel: '拒绝原因：',
  rejectReasonPlaceholder: '如拒绝，需要输入拒绝原因，内容会反馈至待转入学员。50字以内',
  releaseConfirmTip: '当前您已选中{n}条线索，完成释放操作后，该部分线索将不再由您继续跟进，请确认是否继续释放操作',
  remark: '备注',
  remarkFail: '备注失败',
  remarkLabel: '备注',
  remarkSuccess: '备注成功',
  renewService: '续费服务',
  renewalBtn: '续期',
  renewSuccess: '续费成功',
  renqu: '当前认证区域',
  replace: '替换',
  reportActiveLocation: '报备激活地',
  reportAgain: '重新报备',
  reportBy: '报备人',
  reportLocalAgentId: '报备地代理商ID',
  reportLocalAgentName: '报备地代理商名称',
  reportReason: '报备原因',
  reportTime: '报备时间',
  requestFailed: '请求失败',
  resendAfterSeconds: '{n}秒后重新发送',
  resendAfterSecondsShort: '{n}s后重新发送',
  restoreCluesTip: '提示',
  resultPreview: '结果预览',
  resultScoreFormatError: '结果成绩格式不正确',
  reviewResult: '复核结果',
  reviewTime: '复核时间',
  reviewer: '复核人',
  revokeApply: '撤销申报',
  revokeApplyFailed: '撤销申报失败',
  revokeApplySuccess: '撤销申报成功',
  ronglianOutcall: '容联外呼',
  ru: '呼入',
  ruxue: '入学成绩',
  sale: '销售人员',
  saleName: '销售人员',
  san: '高三',
  sanyear: '三年级',
  gaoyi: '高一',
  gaoer: '高二',
  gaosan: '高三',
  gaosi: '高四',
  save: '保存',
  textd4oi: '保存',
  texttx2k: '附件',
  saveAndPublishFail: '保存并发布失败',
  saveSuccess: '保存成功',
  saveStudyScore: '保存学习成绩',
  scheduleTime: '预约时间',
  testConfirm: '测试确认',
  testConfirmTime: '测试确认时间',
  textxan7: '测试报告',
  textyrvw: '测试确认',
  text40sp: '取消',
  textol3p: '查看报告',
  textt828: '查看规划报告',
  text93h4: '再次邀约成功',
  textq0g4: '有效期',
  textpuet: '柜台',
  text2hfg: '复制',
  textw3pi: '确定',
  inviteExperienceSuccess: '邀约体验成功',
  inviteExperience: '邀约体验',
  customerList: '客户列表',
  experienceCourse: '体验课程',
  experienceStartDate: '体验开始日期',
  selectCourseSubject: '选择课程学科',
  pleaseSelectCourseSubject: '请选择课程学科',
  pleaseSelectExperienceStatus: '请选择体验状态',
  pleaseSelectStageFirst: '请先选择阶段',
  pleaseSelectCourse: '请选择课程',
  scheduleTimeMustBeFuture: '选择时间需要大于当前时间',
  school: '学校',
  schoolAddress: '学校地址',
  schoolAddressLabel: '学校地址：',
  schoolApplication: '学校申报',
  schoolArea: '学校地区',
  schoolDetailAddress: '学校详细地址',
  schoolId: '校区ID',
  schoolLabel: '学校:',
  schoolLabel2: '学校：',
  schoolLabelShort: '学校：',
  schoolName: '校区名称',
  schoolApplicationSchoolName: '学校名称',
  schoolNameLabel: '学校名称',
  schoolNameTip: '请输入完整的公校名称，不要使用简称或随略语',
  schoolPlaceholder: '学校',
  schoolScale: '在校人数规模',
  schoolStage: '学校学段',
  schoolStageLabel: '学校学段：',
  scoreFormatError: '格式错误，支持三位整数+一位小数',
  scoreProgressRequired: '成绩进步不能为空',
  scoreProgressLabel: '成绩进度',
  scoringRateLabel: '得分率',
  search: '搜索学员：',
  searchByChargeNamePhone: '根据姓名、负责人电话进行搜索',
  searchByCounterNo: '根据柜台编号进行搜索',
  searchCustomer: '搜索客户：',
  searchCustomerLabel: '搜索客户：',
  searchSchool: '搜索学校',
  searchStudent: '搜索学员',
  selectActualVisitTime: '选择到访时间',
  selectDate: '选择日期',
  selectDateTime: '选择日期时间',
  selectNextFollowTime: '选择下次跟进时间',
  selectPromisedVisitTime: '选择诺访时间',
  selectSchoolLabel: '选择学校：',
  selectStage: '选择学段',
  selectSuccess: '选择成功',
  selectedItems: '已选择',
  sendVerifyCode: '发送验证码',
  sendVerifyCodeSuccess: '发送验证码成功',
  seniorHigh: '高中',
  serviceAbnormal: '服务异常，请稍后重试',
  serviceExpireTip: '当前服务{already}于{time}过期',
  /** 外呼费用中心-服务到期（日期用 .expired-time 包裹，仅 CostCenter 使用） */
  costServiceActiveBefore: '当前服务于',
  costServiceActiveAfter: '过期',
  costServiceExpiredBefore: '当前服务已于',
  costServiceExpiredAfter: '过期',
  servicePerson: '服务人员 ：',
  servicePersonLabel: '服务人员：',
  servicePersonTable: '服务人员',
  serviceTerminated: '服务终止',
  serviceVersion: '服务版本',
  sexLabel: '性别:',
  sheng: '生物',
  shortTermTempPass: '短期临时通行证',
  shu: '推广台数',
  shuxue: '数学',
  siyear: '四年级',
  sizeLimit: '，大小不超过5MB',
  snCode: 'SN码',
  snCodeLabel: 'SN码：',
  softwareActivateTime: '软件激活时间',
  softwareActiveStatus: '软件激活状态',
  sortPlaceholder: '1-98',
  source: '来源:',
  sourceColumn: '来源',
  sourceRequired: '来源不能为空',
  stage: '阶段',
  stageGrade: '阶段年级',
  stageGradeLabel: '阶段/年级:',
  stageGradeLabel2: '阶段年级：',
  stageGradeLabelShort: '阶段年级',
  stageGradeRequired: '年级阶段不能为空',
  stageGradeTable: '阶段 年级',
  stageGradeTable2: '阶段年级',
  startDate: '开始日期',
  statsPeriod: '统计周期：',
  status: '状态',
  statusColon: '状态：',
  storageTime: '入库时间',
  storeRewardTier2MoreThanTier1: '到店奖励第2阶梯邀请人数需要比第1阶梯人数多',
  storeRewardTier3MoreThanTier2: '到店奖励第3阶梯邀请人数需要比第2阶梯人数多',
  student: '学员账号',
  studentAccount: '学生账号',
  studentAccountLabel: '学员账号:',
  studentAccountNotObtained: '未获取到学员账号',
  studentIdRequired: '学生id不能为空！',
  studentInfo: '学生信息',
  leadNameEditOnceTip: '线索姓名仅限修改一次',
  nameEditUpToThreeTimesTip: '姓名仅限修改三次',
  gradeEditOnceTip: '年级仅限修改一次',
  studentIntroLength: '学员介绍50~2000字',
  studentName: '学生姓名',
  studentNameLabel: '学生姓名：',
  studentNameLabelColon: '学生姓名:',
  studentNameOrPhone: '学员姓名/手机号：',
  studentNameRequired: '学生姓名不能为空',
  studentStoryMin50Chars: '学员故事不能少于50字',
  studentTransferApply: '学员转入申请',
  subTagColumn: '子标签',
  subTagLabel: '子标签:',
  subTagNameRequired: '子标签名称不能为空',
  subject: '科目',
  subjectTotalPositiveInteger: '学科总分为正整数',
  subjectTotalScorePositiveInteger: '学科总分为正整数',
  submitAudit: '提交审核',
  submitAuditFailed: '提交审核失败',
  submitAuditSuccess: '提交审核成功',
  submitFailed: '提交失败',
  submitNow: '立即申报',
  submitSuccess: '提交成功',
  subscribed: '已订阅',
  subscriptionSubject: '订阅学科',
  success: '成功',
  suochaxun: '线索查询',
  pleaseEnterClueNameOrMobile: '请输入线索名或手机号',
  supervisionFeeRequired: '督学费不能为空',
  supervisionFeeLabel: '督学费',
  supervisionRenewConflict: '督学续费无法与学习机新签、督学新签共存',
  supervisorConversionNum: '督学转化数',
  supervisorConversionRate: '督学转化率',
  supervisorConversionRatio: '督学转化占比',
  supervisorExpireTo: '督学有效期至',
  supervisorExpireToTable: '督学有效期',
  supervisorStatusLabel: '督学状态：',
  markSupervisorNoneDetailTip: '选择不督学后，系统会自动解除学员和分析师的关系，后续该学员学情跟进，可以前往"大模型数据分析服务系统 - 未督学学员"页面查看',
  unsupervisedStudentDataTipDetail: '不督学学员的学情数据，可前往"大模型数据分析服务系统-未督学学员页面"查看',
  supervisorValidDateLabel: '督学有效期：',
  supervisorExpireNextDayTip: '督学结束时间的次日，客户督学状态自动变更为“督学到期”',
  supervisorStoreLabel: '督学门店：',
  pleaseSelectSupervisorStore: '请选择督学门店',
  remarkLabelWithColon: '备注：',
  syncCourseStatusLabel: '同步课状态 ：',
  syncCourseStatusTable: '同步课状态',
  systemError: '系统异常',
  tagCategoryLabel: '标签分类:',
  tagLabel: '标签:',
  tagLabelShort: '标签：',
  tagNameLabel: '标签名称：',
  tagTypeColumn: '标签类型',
  taskStatusLabel: '任务状态',
  tempPassHolding: '临时通行证持有中',
  tempPassTip: '临时通行证可以让近期同步课学习表现未达标的学员暂时继续学习同步课，请谨慎发放。',
  tempPassTypeLabel: '临时通行证类型：',
  templateBgColor: '模板背景色:',
  templateDelete: '模板删除',
  templateNameLabel: '活动模板名称:',
  templateNameSearchLabel: '模板名称：',
  templateOffShelf: '模板下架',
  templateOffShelfSuccess: '下架成功',
  templatePublish: '模板发布',
  templateSaveSuccess: '{flag}成功',
  templateTip: '请下载最新模版，且请勿修改或删除表格前两行',
  templateTypeLabel: '活动模板类型:',
  templateListTemplateTypeLabel: '模板类型:',
  templateListPleaseSelectTemplateType: '请选择模板类型',
  templateListTagSelectPlaceholder: '标签',
  testStatus: '测试状态',
  testTime: '测评时间',
  text0b7p: '标签',
  text0pmo: '搜索参数',
  text0rj0: '全部',
  textys3t: '科目',
  textys4t: '学习科目',
  text7041: '进步成绩',
  texty59e: '入学成绩',
  textxjvh: '排序',
  text0zrv: '保持空',
  text115o: '查看报告',
  text126z: '获取表格数据',
  text14yy: '厂商退换货',
  text1dm0: '礼包领取状态',
  text1g8k: '阶段列表',
  text1h2y: '注意',
  text1sge: '扫码查看案例详情',
  scoreCaseCardTooltipViews: '浏览量',
  scoreCaseCardTooltipCollects: '收藏量',
  scoreCaseCardTooltipShares: '分享量',
  scoreCaseCardTooltipCampusUse: '使用校区量',
  scoreCaseCardStudyDaysLabel: '学习天数',
  scoreCaseCardDownloadPoster: '下载海报，分享给朋友',
  scoreCaseCardShareImageFileName: '案例分享.png',
  scoreCaseCardDayUnit: '天',
  scoreCaseCardTitleDaysImprove: '{days}天提升',
  scoreCaseCardTitleScorePoints: '{score}分',
  scoreCaseCardTagScoreGain: '提升{score}分',
  scoreCaseCardTagDaysSinceEnroll: '入学{days}天',
  scoreCaseCardScoreWithUnit: '{score}分',
  text1tpq: '关闭预览',
  text1uvl: '筛选值',
  text245v: '处理复选框的变化并相应地更新搜索参数',
  text2chn: '当前筛选结果为',
  text2ffx: '全选',
  text2kky: '不能随便写',
  text2m1b: '这里的',
  text2oge: '本校标签',
  text2u5x: '取消后',
  text2v8u: '数据的总长度',
  text30tx: '服务端类型',
  text39fb: '请输入学员故事',
  text3l9l: '对表格的操作',
  text3pnx: '松鼠',
  text3qnn: '必有字段',
  text3qx2: '学习科目',
  text3w27: '报告名称',
  text3uew: '排序',
  text41s1: '搜索内容',
  text429c: '表单',
  text4a3g: '或者更换了搜索条件',
  text47n0: '社区店',
  text4l7a: '经典案例',
  text4lpi: '知识点数',
  text5fi2: '这里的',
  text5jly: '获取科目列表',
  text5mof: '审核状态',
  text5mwq: '助力到店转化率',
  text5pnc: '点击查看助力人数详情',
  text5tye: '实际学习情况',
  text5x5t: '获取热门案例列表并更新组件状态',
  text5xnm: '表格',
  text62uf: '使用校区量',
  text64ws: '选择登录类型',
  text6d5o: '导入详情',
  text6fpu: '发布后',
  text793f: '查询出错',
  text7dyv: '切换组件的关闭状态',
  text7k6h: '取消订阅',
  text7t2x: '登录类型',
  text7tft: '意向级别',
  text7tmb: '来源',
  text7xij: '测试报告',
  text7y5k: '接收',
  text80zn: '打地基降级',
  text825h: '客户端话机类型',
  text85vb: '本校案例',
  text8ej2: '邀请人',
  text8kwm: '请先选择阶段',
  text16d6: '报告类型',
  textua16: '请选择科目',
  text8nto: '当前排名',
  text925t: '导入结果',
  text95jx: '那么',
  text9y83: '助力人数详情',
  text9g4w: '发送',
  text9qrf: '修改进步方案',
  texta8dx: '更多选项',
  textae2r: '导出当前明细',
  textapni: '获取表单数据',
  textawcc: '登录参数',
  textbayd: '全部',
  textbbau: '学员故事',
  textbdya: '微信昵称',
  textbidw: '阶段',
  textbj5w: '小学',
  textbkhp: '投票学员姓名',
  textbseu: '导流课报告',
  textch0r: '修改学习成绩',
  textcjnr: '或者是手动置空之后点击搜索',
  textczme: '手机',
  textdcsw: '提升',
  textdci8: '我的收藏',
  textddaj: '这里的',
  textdds7: '推荐学员姓名',
  textdffx: '不能随便写',
  textdo4x: '注意',
  textdpjq: '连接地址',
  textdrns: '请输入活动名称',
  textds5q: '数据的总长度',
  texte50z: '获取表单数据',
  texte96r: '线索规则',
  texteklv: '案例展示信息',
  textk19t: '请先选择学员并完善案例信息！',
  text5xd7: '学后成绩',
  text6wd3: '进步方案',
  text7b65: '任务卡数',
  textc5y4: '进步效果',
  textccnj: '学习天数',
  textdqe9: '正确率',
  textdzp8: '学习轨迹',
  textg8s8: '学前成绩',
  textsbo6: '总题数',
  textu1i9: '编辑学员故事',
  hourlong: '每周打地基时长',
  smallhour: '小时',
  share: '分享',
  textekyu: '打地基重学',
  textelrk: '跟进人',
  texteltn: '搜索用户',
  textf5t0: '初中',
  textf9ue: '新版工具',
  textfbrl: '请输入用户',
  textfyvk: '浏览量',
  textgnlu: '智适应教育',
  textgvft: '进步成绩',
  textgz5r: '被邀请人',
  texth2dc: '正式课',
  texth39f: '来源管理',
  texthbj2: '请录入',
  texthjji: '请到松果',
  texti3md: '登录到的技能组',
  texti3uw: '默认排序',
  textibiy: '导出明细',
  textif9n: '执行搜索',
  textiu8r: '关闭柜台弹框',
  textiune: '已有',
  textj6ki: '获取表单数据',
  textj8or: '表单数据',
  textjw1n: '科技改变教育',
  textjw4y: '备用电话',
  textl0ql: '话机',
  textljf2: '旧版工具',
  textlpqu: '节课',
  textltlk: '进入知识星空',
  textlzrj: '错误原因',
  textm00g: '正课报告',
  textm2yt: '邀请进展',
  textm7oq: '当前票数',
  textmpf2: '发布成功',
  textmr1r: '导出图片',
  textn2qz: '跟进状态',
  textn2wh: '成绩进步',
  textn7no: '审核',
  textn7qn: '文件名',
  textni8p: '厂商退换货',
  textnkpc: '入学',
  textno2h: '获取阶段和科目的字典列表并更新组件状态',
  textnyic: '关闭柜台的',
  texto9pn: '可有字段',
  textof4b: '根据用户选择更新阶段过滤器',
  textoh9j: '根据用户选择更新科目过滤器',
  textonft: '取消订阅',
  textoryg: '会决定最后的接口参数名称',
  textoz2b: '表格数据',
  textozwa: '入学成绩',
  textpd4r: '家庭住址',
  textpgqw: '助力人数',
  textpuh0: '课程学习情况',
  textpzrd: '上课数',
  textq1x0: '审核',
  textq7fj: '进步课程安排',
  textqgox: '头像',
  textqian: '取消发布',
  textqjmj: '录入',
  textqmvx: '添加进步案例权限',
  textrgur: '表格标题',
  textrhrk: '修改',
  textrixp: '监控功能使用',
  textrsdh: '软话机',
  textrx7n: '是否需要发布此案例',
  textrxnr: '顶部返回功能',
  texthkhr: '新增推荐',
  texts0fj: '学员推荐',
  texts56p: '登录',
  texts6a0: '使用校区数',
  textsauw: '使用的',
  textschc: '加载失败',
  textsdmg: '都设置为默认的',
  textsfjp: '本省热榜',
  textz9y4: '全国热榜',
  textsgcw: '获取阶段列表',
  textsycd: '知识星空',
  textt6gm: '阶段',
  textt612: '标签管理',
  textygf8: '科目',
  texttghz: '切换面板',
  texttkth: '会决定最后的接口参数名称',
  texttxub: '否则都应为默认的',
  textug0h: '是否取消发布此案例',
  textuj8v: '发布',
  textul9z: '查看报告跳转',
  textv3l2: '下载海报',
  textvfnm: '到店人数',
  textvjwj: '加载失败',
  textvntq: '请求头中的验证信息等',
  textvoqt: '搜索用户',
  textw1de: '阶段',
  textw94g: '请输入活动',
  textwi6w: '页面更新',
  textwmyx: '线索姓名',
  textwvyp: '登录方式',
  textx2bf: '试听课报告',
  textx7ij: '条学员成绩信息',
  textxrls: '登出',
  textxvbk: '失效原因',
  textxxuo: '点击清空按钮',
  texty6pb: '收藏量',
  textyiar: '转介绍活动明细导出',
  textyl8q: '助力人数弹框',
  textyr7v: '成交人数',
  textytgg: '取消订阅',
  textzlms: '天提升',
  textzqig: '发布进步案例权限',
  textzrxs: '性别',
  textzy8y: '投票用户',
  time: '最后编辑时间',
  titleBgPicLabel: '标题背景图:',
  to: '至',
  todayClaimable: '今日可领取：',
  totalCost: '累计消费',
  totalDataCount: '总数据量',
  totalLeads: '线索总量',
  totalScoreLabel: '总分',
  totalUnits: '汇总台数：',
  trainee: '学员',
  transferApplySuccessTip: '用户{name}（{account}）已提交转入服务中心申请。请联系家长在松鼠Ai智能学习机家长通进行确认，如7天内家长未进行确认，转入服务中心失败，需重新提交申请',
  transferFailed: '转入失败',
  transferLead: '转交线索',
  transferLeadTip:
    '转交后，线索跟进人将更新为您指定的同事，请选择您要转交的员工账号',
  selectStaff: '选择员工',
  pleaseSelectStaff: '请选择员工',
  onlyNormalStaffCanTransfer: '仅账号状态为"正常"的员工可进行转交',
  transferShort: '转交',
  transferToServiceCenter: '转入服务中心',
  trialStatusConverted: '已转化',
  trialStatusExperiencing: '体验中',
  trialStatusExpired: '已过期',
  trialStatusTerminated: '已终止',
  type: '类型',
  unknownOrderStatus: '未知的订单状态',
  unmarkPrototype: '取消样机标记',
  updateBtn: '更新',
  updateCountTip: '数据仅统计修改系统已有线索',
  updateImport: '更新导入',
  updateImportTip: '您正在更新已导入的【{fileName}】表格内的数据，若表内包含还未上传的线索本次操作将一并上传。',
  updatedCount: '已更新',
  uploadBeforeTip: '上传前请',
  uploadDoc: '上传文档',
  uploadFail: '上传失败',
  uploadFailed: '上传失败，临时 Token 已过期，请刷新重试！',
  uploadImage: '上传图片：',
  uploadMaterial: '上传资料',
  uploadStatusError: '文件上传状态异常',
  uploadSuccess: '上传成功',
  uploadTipSuffix: '并按照规范录入线索，否则将无法导入',
  uploadVideo: '上传视频：',
  uploadVideoSize100MB: '上传视频大小不能超过 100MB!',
  uploadVoucherImage: '上传凭证图片',
  uploadVoucherTip: '只能上传jpg/png文件，且不超过10M，最多6张',
  uploading: '上传中...',
  useDeskPhoneOutcall: '使用座机外呼',
  usePhoneOutcall: '使用手机号外呼',
  userNameLabel: '用户姓名：',
  userProfile: '用户档案',
  userProfileLabel: '用户档案：',
  userProfileLabelForm: '用户档案：',
  validateFailed: '校验失败，请稍后重试',
  validityDaysUnit: '{days}天（{date}）',
  validityEndLabel: '有效期截止：',
  validityPeriod: '有效期',
  verifyCodeError: '验证码错误',
  verifyCodeLabel: '手机验证码:',
  verifyCodeRequired: '验证码不能为空',
  verifyCodeSendSuccess: '验证码发送成功',
  optional: '可选',
  sipOptionalTip: '使用的SIP号码（可选，更新SIP号时填写）',
  verifyFail: '核销失败',
  verifyPhoneRequired: '需验证客户手机号有效性后才可进行开通体验。',
  verifyPhoneTitle: '验证手机号',
  verifySuccess: '核销成功',
  video: '视频',
  videoExceed20M: '视频大于20M，请压缩后上传!',
  videoExceed50M: '视频大于50M，请压缩后上传!',
  videoFormatMp4Avi: '视频只能是 MP4/AVI 格式!',
  videoFormatTip: '支持mp4/AVI格式，最大文件限制50MB',
  videoMaterial: '视频资料',
  videoSizeExceeded: '上传视频大小不能超过 300MB!',
  view: '查看',
  viewExamInfo: '查看考试信息',
  viewFace: '查看人脸',
  viewImage: '查看图片',
  viewInfo: '查看信息',
  viewProgress: '查看进度',
  viewSchoolInfo: '查看学校信息',
  visitStore: '到访门店:',
  visitStoreLabel: '到访门店：',
  visitStoreLabelShort: '到访门店：',
  visitTimeLabel: '到访时间：',
  week: '统计周期：',
  weekPromiseVisitLabel: '本周诺访：',
  thisWeekPromisedVisit: '本周诺访',
  whitelist: '白名单',
  withdrawSuccess: '撤回成功',
  wuyear: '五年级',
  xue: '化学',
  xuexiao: '学校',
  year: '阶段年级',
  yes: '是',
  yi: '归一化报告',
  yiyear: '一年级',
  yuanUnit: '元',
  zhanghuyouqi: '账户有效期',
  commonGrade: '通用',
  taskStatusCompleted: '已完成',
  taskStatusNotStarted: '未开始',
  taskStatusOverdue: '已逾期',
  taskStatusCancelled: '已取消',
  followUpToday: '今日待跟进',
  followUpOverdue: '逾期未跟进',
  followUpNotStarted: '未开始',
  followUpCompleted: '已完成',
  followUpCancelled: '已取消',
  pendingFollowUp: '待跟进',
  calledPhone: '已电话',
  addedWeChat: '已加微',
  promisedVisit: '已诺访',
  visited: '已到访',
  dealDone: '已成交',
  myLeadsRule: '我的线索规则',
  autoRecycleMechanism: '自动回收机制',
  switchOn: '开',
  switchOff: '关',
  autoRecycleTip: '开启后可设置超过一定天数未跟进未转化的线索由系统定时自动收回',
  daysNotFollowed: '天未跟进',
  daysNotConverted: '天未转化',
  day: '天',
  pleaseEnterDays: '请填写天数',
  leadPhoneDisplay: '线索手机号展示',
  leadPhoneDisplayTip: '被选中的人员将在经销商系统中直接看到和导出线索的完整手机号',
  publicPoolRule: '公有池规则',
  publicPoolSetting: '公有池开启设置',
  publicPoolEnableTip: '开启后团队内的销售均可看见公有池且销售可自行从公有池领取待分配线索',
  publicPoolDisableTip: '关闭后团队内的销售全不可看见公有池销售无法自行领取线索线索需由管理员分配',
  allocatedOver: '分配领取后超过',
  autoRecycleDays: '的线索将由系统到期自动收回',
  // ClueManagement additional keys
  followUpTodayQuick: '今日待跟进',
  daysNotFollowedQuick: '7日未跟进',
  daysNotConvertedQuick: '30日未转化',
  pendingAllocateStatus: '待分配',
  pendingFollowStatus: '待跟进',
  calledPhoneStatus: '已电话',
  addedWeChatStatus: '已加微',
  promisedVisitStatus: '已诺访',
  visitedStatus: '已到访',
  dealDoneStatus: '已成交',
  calledPhoneOption: '已电话',
  addedWeChatOption: '已加微',
  promisedVisitOption: '已诺访',
  visitedOption: '已到访',
  dealDoneOption: '已成交',
  customerNameColumn: '客户姓名',
  mobileColumn: '手机号',
  followStatusColumnLabel: '跟进状态',
  followPersonColumnLabel: '跟进人',
  smallClass: '小班',
  middleClass: '中班',
  bigClass: '大班',
  grade1: '一年级',
  grade2: '二年级',
  grade3: '三年级',
  grade4: '四年级',
  grade5: '五年级',
  grade6: '六年级',
  grade7: '七年级',
  grade8: '八年级',
  grade9: '九年级',
  senior1: '高一',
  senior2: '高二',
  senior3: '高三',
  senior4: '高四',
  commonGradeOption: '通用',
  inviteKnowledgeGapExam: '邀约知识漏洞大体检',
  inviteBy: '邀约人',
  knowledgeGapBigExperience: '知识漏洞大体验',
  inviteTime: '邀约时间',
  appointmentVisitTime: '预约到访时间',
  visitStatus: '到访状态',
  visitTime: '到访时间',
  inviteByLegacy: '邀约人',
  experienceStatus: '体验状态',
  courseSubject: '课程科目',
  subject: '科目',
  version: '版本',
  testDuration: '测试用时',
  unit: '单元',
  knowledgePointMasteryRate: '知识点掌握率',
  testTime: '测试时间',
  nameLabelColumn: '姓名',
  stageGradeColumn: '阶段年级',
  learningCenterAccountColumn: '学习中心账号',
  analystPersonColumn: '分析师人员',
  allLeadsTab: '"全部线索"',
  allLeadsTabDesc: '用于门店管理人员管理、分配、查看线索',
  myLeadsTab: '"我的线索"',
  myLeadsTabDesc: '用于销售管理、查看线索',
  publicPoolTab: '公有池用于便携管理无人跟进的线索',
  recycleBinTab: '回收站用于查看和管理标记失效的线索',
  pleaseEnterMobile: '请输入手机号码',
  batchRecallAction: '批量收回',
  batchReleaseAction: '批量释放',
  batchRestoreAction: '批量还原',
  // ClueManagement config.js labelKeys
  tag1: '标签',
  source2: '来源',
  operationMode3: '运营方式',
  tag4: '标签',
  source5: '来源',
  operationMode6: '运营方式',
  source7: '来源',
  tag8: '标签',
  operationMode9: '运营方式',
  source10: '来源',
  marker11: '标记人',
  invalidReason12: '失效原因',
  intentLevel13: '意向程度',
  source14: '来源',
  tag15: '标签',
  operationMode16: '运营方式',
  intentLevel17: '意向程度',
  tag18: '标签',
  source19: '来源',
  operationMode20: '运营方式',
  source21: '来源',
  tag22: '标签',
  source23: '来源',
  tag24: '标签',
  marker25: '标记人',
  markedInvalidReason26: '标记失效原因',
  // ClueManagement/config.js only（避免占用 time、name、mobile 等通用键）
  clueMgmt_ph_leadNameOrPhone: '请输入线索名或手机号',
  clueMgmt_ph_selectThisWeekVisit: '请选择本周诺访',
  clueMgmt_ph_selectCreator: '请选择创建人',
  clueMgmt_ph_selectMarker: '请选择标记人',
  clueMgmt_lastAssignTime: '最近分配时间',
  clueMgmt_lastFollowPerson: '最近跟进人',
  clueMgmt_lastFollowRecord: '最近跟进记录',
  clueMgmt_invalidTime: '失效时间',
  clueMgmt_markInvalidTime: '标记失效时间',
  clueMgmt_gradeOnly: '年级',
  clueMgmt_mobileNumber: '手机号码',
  clueMgmt_nextFollowTime: '下次跟进时间',
  followStatus: '跟进状态',
  follower: '跟进人',
  claimTime: '申领时间',
  homeworkDetail: '作业详情',
  // ReferralActivities config.js
  activity: '活动',
  enterActivity: '请输入活动',
  enterActivityName: '请输入活动名称',
  phone: '手机号',
  enterPhone: '请输入手机号',
  inviterWxNickname: '邀请人微信昵称',
  inviterWxAvatar: '邀请人头像',
  inviteeWxNickname: '被邀请人微信昵称',
  inviteeWxAvatar: '被邀请人头像',
  inviteePhone: '被邀请人手机号',
  inviteProgress: '邀请进度',
  invitationTime: '邀请时间',
  retentionTime: '留存时间',
  queryBtn: '查询',
  resetBtn: '重置',
  auto_932: '开通外呼预售优惠',
  auto_933: '预售优惠价',
  auto_406934: '原价¥406',
  auto_935: '*外呼技术由',
  auto_936: '作业帮、猿辅导同一供应商提供',
  auto_937: '*涵盖全国各地域三大运营商号码资源',
  auto_938: '全国各地域三大运营商号码资源',
  auto_939: '*系统自动分配并外显本地号码，',
  auto_940: '无需自行准备号码资源',
  auto_941: '解决号码标记和封禁问题',
  auto_942: '*新开通',
  auto_943: '需支付技术开通费，后续续费不再重复收取',
  auto_944: '*按月结算，',
  auto_945: '不限使用人数',
  auto_946: '开通费：',
  auto_947: '限时优惠1折，原价288.00元',
  auto_948: '套餐费：',
  auto_949: '不限人数，含500分钟免费时长，超出部分0.12元/分钟',
  auto_950: '开通月数：',
  auto_951: '预售最多开通12个月',
  auto_989: '支付前请您先阅读并勾选外呼服务的',
  auto_990: '开通使用协议',
  auto_954: '合计：',
  auto_992: '付款',
  auto_958: '本次支付将扣除：',
  auto_959: '请确认是否取消订单，一旦取消，已支付款项会退回',
  auto_960: '对应的代理商账户和调整对应期货订单额度！',
  auto_1003: '支付设置',
  auto_1004: '自动续费',
  auto_962: '自动续费开启中，外呼服务到期后默认170元/月自动续费，费用默认从现金账户中扣除',
  auto_1005: '充值话费',
  auto_1006: '当前余额：',
  auto_1007: '充值话费：',
  auto_1008: '请输入数字',
  auto_964: '（话费单价0.12元/分钟）',
  auto_1009: '待支付：',
  auto_980: '支付前请您先阅读并勾选外呼服务的',
  auto_981: '开通使用协议',
  auto_983: '付款',
  auto_1015: '开通外呼服务',
  auto_1011: '开通费:',
  auto_969: '限时优惠1折',
  auto_970: '（原价288元）',
  auto_1016: '套餐费:',
  auto_984: '（不限人数，含500分钟免费时长，超出部分0.12/分钟）',
  auto_1017: '开通月数:',
  auto_1018: '合计支付:',
  auto_985: '到期自动续费',
  auto_973: '① 支付完成后，总部将在',
  auto_974: '7-10个工作日',
  auto_975: '内完成商务对接及服务开通，部分地区由于号码资源有限，开通时间相对较长，开通状态请关注经销商系统-外呼中心-费用管理的订单状态',
  auto_17976: '② 为避免耽误您的外呼业务开展，根据您选择的开通月数，到期后默认170元/月自动续费，费用默认从现金账户中扣除，',
  auto_987: '可随时关闭',
  auto_978: '③ 灵活使用，',
  auto_979: '支持退费',
  auto_965: '支付前请您先阅读并勾选外呼服务的',
  auto_966: '开通使用协议',
  auto_968: '付款',
  auto_1010: '开通外呼服务', // 与历史页面一致：续费弹窗标题同为「开通外呼服务」
  auto_1012: '套餐费:',
  auto_971: '（不限人数，含500分钟免费时长，超出部分0.12/分钟）',
  auto_1013: '开通月数:',
  auto_1014: '合计支付:',
  auto_972: '到期自动续费',
  auto_17986: '① 为避免耽误您的外呼业务开展，根据您选择的开通月数，到期后默认170元/月自动续费，费用默认从现金账户中扣除，',
  auto_977: '可随时关闭',
  auto_988: '③ 灵活使用，支持退费',
  auto_952: '支付前请您先阅读并勾选外呼服务的',
  auto_953: '开通使用协议',
  auto_956: '付款',
  auto_993: '您的外呼服务正在生效中，为避免重复缴纳开通费，若您需要续费外呼服务请您使用',
  auto_994: '经销商系统-外呼中心-费用管理-“续费”',
  auto_995: '功能，若有疑问您可优先咨询松鼠Ai智能客服',
  auto_996: '您的外呼服务正在开通中，预计下单后7个工作日内可完成，请勿重复下单，若有疑问您可优先咨询松鼠Ai智能客服',
  auto_998: '您尚未开通外呼服务，请您先使用',
  auto_999: '经销商系统-外呼中心-费用管理-“开通服务”',
  auto_1000: '功能进行开通缴费，若有疑问您可优先咨询松鼠Ai智能客服',
  auto_1001: '您的外呼服务正在开通中，预计下单后7个工作日内可完成，请勿重复续费，若有疑问您可优先咨询松鼠Ai智能客服',
  auto_603: '开启成功',
  auto_604: '关闭成功',
  auto_605: '开通服务时的逻辑失败',
  auto_606: '支付成功',
  auto_607: '支付失败',
  auto_591: '微传单',
  auto_592: '创建活动',
  auto_593: '每日一图',
  auto_594: '查看大图',
  auto_595: '查看视频',
  auto_596: '微传单',
  auto_806: '活动运营规则',
  auto_807: '本人已详细阅读并熟知广告法的全部内容承诺严格遵守广告法的规定',
  auto_808: '广告法词汇使用须知',
  auto_2809: '广告法自1994年10月27日公布1995年2月1日实施至',
  auto_24810: '新广告法于十二届全国人大常委会第十四次会议2015年4月',
  auto_811: '总则',
  auto_812: '第一条为了规范广告活动保护消费者的合法权益促进广告业的健康发',
  auto_813: '第二条在中华人民共和国境内商品经营者或者服务提供者通过一定媒',
  auto_814: '第三条广告应当真实合法以健康的表现形式表达广告内容符合社会主',
  auto_815: '第四条广告不得含有虚假或者引人误解的内容不得欺骗误导消费者广',
  auto_816: '第五条广告主广告经营者广告发布者从事广告活动应当遵守法律法规',
  auto_817: '第六条国务院工商行政管理部门主管全国的广告监督管理工作国务院',
  auto_818: '第七条广告行业组织依照法律法规和章程的规定制定行业规范加强行',
  auto_819: '广告内容准则及行为规范',
  auto_820: '第八条广告中对商品的性能功能产地用途质量成分价格生产者有效期',
  auto_821: '广告中表明推销的商品或者服务附带赠送的应当明示所附带赠送商品',
  auto_822: '法律行政法规规定广告中应当明示的内容应当显著清晰表示',
  auto_823: '第九条广告不得有下列情形',
  auto_824: '一使用或者变相使用中华人民共和国的国旗国歌国徽军旗军歌军徽',
  auto_825: '二使用或者变相使用国家机关国家机关工作人员的名义或者形象',
  auto_826: '三使用国家级最高级最佳等用语',
  auto_827: '四损害国家的尊严或者利益泄露国家秘密',
  auto_828: '五妨碍社会安定损害社会公共利益',
  auto_829: '六危害人身财产安全泄露个人隐私',
  auto_830: '七妨碍社会公共秩序或者违背社会良好风尚',
  auto_831: '八含有淫秽色情赌博迷信恐怖暴力的内容',
  auto_832: '九含有民族种族宗教性别歧视的内容',
  auto_833: '十妨碍环境自然资源或者文化遗产保护',
  auto_834: '十一法律行政法规规定禁止的其他情形',
  auto_835: '第十条广告不得损害未成年人和残疾人的身心健康',
  auto_836: '第十一条',
  auto_837: '广告内容涉及的事项需要取得行政许可的应当与许可的内容相符合',
  auto_838: '广告使用数据统计资料调查结果文摘引用语等引证内容的应当真实准',
  auto_839: '第十二条',
  auto_840: '广告中涉及专利产品或者专利方法的应当标明专利号和专利种类未取',
  auto_841: '禁止使用未授予专利权的专利申请和已经终止撤销无效的专利作广告',
  auto_842: '第十三条',
  auto_843: '广告不得贬低其他生产经营者的商品或者服务',
  auto_844: '第二十四条教育培训广告不得含有下列内容',
  auto_845: '一对升学通过考试获得学位学历或者合格证书或者对教育培训的效果',
  auto_846: '二明示或者暗示有相关考试机构或者其工作人员考试命题人员参与教',
  auto_847: '三利用科研单位学术机构教育机构行业协会专业人士受益者的名义或',
  auto_848: '第二十五条招商等有投资回报预期的商品或者服务广告应当',
  auto_849: '对可能存在的风险以及风险责任承担有合理提示或者警示',
  auto_850: '并不得含有下列内容',
  auto_851: '一对未来效果收益或者与其相关的情况作出保证性承诺明示或者暗示',
  auto_852: '二利用学术机构行业协会专业人士受益者的名义或者形象作推荐证明',
  auto_853: '第二十八条广告以虚假或者引人误解的内容欺骗误导消费者的构成虚',
  auto_854: '一商品或者服务不存在的',
  auto_855: '二商品的性能功能产地用途质量规格成分价格生产者有效期限销售状',
  auto_856: '三使用虚构伪造或者无法验证的科研成果统计资料调查结果文摘引用',
  auto_857: '四虚构使用商品或者接受服务的效果的',
  auto_858: '五以虚假或者引人误解的内容欺骗误导消费者的其他情形',
  auto_859: '第三十三条广告主或者广告经营者在广告中使用他人名义或者形象的',
  auto_860: '第三十八条广告代言人在广告中对商品服务作推荐证明应当依据事实',
  auto_861: '并不得为其未使用过的商品或者未接受过的服务作推荐证明不得利用',
  auto_862: '对在虚假广告中作推荐证明受到行政处罚未满三年的自然人法人或者',
  auto_863: '第三十九条不得在中小学校幼儿园内开展广告活动不得利用中小学生',
  auto_864: '第四十条在针对未成年人的大众传播媒介上不得发布医疗药品保健食',
  auto_865: '一劝诱其要求家长购买广告商品或者服务',
  auto_866: '二可能引发其模仿不安全行为',
  auto_867: '第四十四条利用互联网从事广告活动适用本法的各项规定利用互联网',
  auto_868: '应当显著标明关闭标志确保一键关闭',
  auto_869: '法律责任',
  auto_870: '第五十五条违反本法规定发布虚假广告的由工商行政管理部门责令停',
  auto_871: '处广告费用三倍以上五倍以下的罚款',
  auto_872: '广告费用无法计算或者明显偏低的处二十万元以上一百万元以下的罚',
  auto_873: '两年内有三次以上违法行为或者有其他严重情节的处广告费用五倍以',
  auto_874: '广告费用无法计算或者明显偏低的处一百万元以上二百万元以下的罚',
  auto_875: '可以吊销营业执照并由广告审查机关撤销广告审查批准文件一年内不',
  auto_876: '广告主广告经营者广告发布者有本条第一款第三款规定行为',
  auto_877: '构成犯罪的依法追究刑事责任',
  auto_878: '第五十六条违反本法规定发布虚假广广告经营者广告发布者不能提供',
  auto_879: '使购买商品或者接受服务的消费者的合法权益受到损害的由广告主依',
  auto_880: '关系消费者生命健康的商品或者服务的虚假广告造成消费者损害的其',
  auto_881: '第五十七条有下列行为之一的由工商行政管理部门责令停止发布广告',
  auto_882: '处二十万元以上一百万元以下的罚款情节严重的并可以吊销营业执照',
  auto_883: '对广告经营者广告发布者由工商行政管理部门没收广告费用处二十万',
  auto_884: '一发布有本法第九条第十条规定的禁止情形的广告的',
  auto_885: '二违反本法第十五条规定发布处方药广告药品类易制毒化学品广告戒',
  auto_886: '三违反本法第二十条规定发布声称全部或者部分替代母乳的婴儿乳制',
  auto_887: '四违反本法第二十二条规定发布烟草广告的',
  auto_888: '五违反本法第三十七条规定利用广告推销禁止生产销售的产品或者提',
  auto_889: '六违反本法第四十条第一款规定在针对未成年人的大众传播媒介上发',
  auto_890: '第五十八条有下列行为之一的由工商行政管理部门责令停止发布广告',
  auto_891: '处广告费用一倍以上三倍以下的罚款广告费用无法计算或者明显偏低',
  auto_892: '一违反本法第十六条规定发布医疗药品医疗器械广告的',
  auto_893: '二违反本法第十七条规定在广告中涉及疾病治疗功能以及使用医疗用',
  auto_894: '三违反本法第十八条规定发布保健食品广告的',
  auto_895: '四违反本法第二十一条规定发布农药兽药饲料和饲料添加剂广告的',
  auto_896: '五违反本法第二十三条规定发布酒类广告的',
  auto_897: '六违反本法第二十四条规定发布教育培训广告的',
  auto_898: '七违反本法第二十五条规定发布招商等有投资回报预期的商品或者服',
  auto_899: '八违反本法第二十六条规定发布房地产广告的',
  auto_900: '九违反本法第二十七条规定发布农作物种子林木种子草种子种畜禽水',
  auto_901: '十违反本法第三十八条第二款规定利用不满十周岁的未成年人作为广',
  auto_902: '十一违反本法第三十八条第三款规定利用自然人法人或者其他组织作',
  auto_903: '十二违反本法第三十九条规定在中小学校幼儿园内或者利用与中小学',
  auto_904: '十三违反本法第四十条第二款规定发布针对不满十四周岁的未成年人',
  auto_905: '十四违反本法第四十六条规定未经审查发布广告的',
  auto_906: '禁用词汇',
  auto_907: '一与最有关',
  auto_908: '最最佳最具最爱最赚最优最优秀最好最大最大程度最高最高级最高档',
  auto_909: '二与第一有关',
  auto_910: '第一中国第一全网第一销量第一排名第一唯一第一品牌NO1TOP',
  auto_911: '三与级极有关',
  auto_912: '国家级国家级产品全球级宇宙级世界级顶级顶尖尖端顶级工艺顶级享',
  auto_913: '四与首家国有关',
  auto_914: '首个首选独家独家配方首发全网首发全国首发XX网独家首次首款全',
  auto_915: '五与品牌有关',
  auto_916: '大牌金牌名牌王牌领袖品牌世界领先遥遥领先领导者缔造者创领品牌',
  auto_917: '六与虚假有关',
  auto_918: '史无前例前无古人永久万能祖传特效无敌纯天然100高档正品真皮',
  auto_919: '七与权威有关',
  auto_920: '老字号中国驰名商标特供专供专家推荐质量免检无需国家质量检测免',
  auto_921: '八与欺诈有关涉嫌欺诈消费者',
  auto_922: '点击领奖恭喜获奖全民免单点击有惊喜点击获取点击转身点击试穿点',
  auto_923: '九涉嫌诱导消费者',
  auto_924: '秒杀抢爆再不抢就没了不会更便宜了没有他就XX错过就没机会了万',
  auto_925: '十与时间有关',
  auto_926: '限时必须具体时间今日今天几天几夜倒计时趁现在就仅限周末周年庆',
  auto_929: '创建活动',
  auto_597: '微信扫一扫预览',
  auto_598: '微传单',
  auto_599: '每日一图',
  auto_600: '微视频',
  auto_601: '每日一图',
  auto_602: '微视频',
  auto_638: '成绩进步',
  auto_639: '学科总分',
  auto_640: '请输入3位正整数',
  auto_641: '入学成绩',
  auto_644: '格式支持3位数加一位小数',
  auto_643: '结课成绩',
  auto_642: '格式支持3位数加一位小数',
  auto_608: '添加学员故事',
  auto_645: '编辑学员故事',
  auto_646: '建议描述学员的入学背景入学学习时的学习情况学习状态使用松鼠A',
  auto_647: '上传图片',
  auto_609: '保存信息',
  auto_610: '学习情况',
  auto_611: '总学习时长',
  auto_636: '小时',
  auto_613: '累计天数',
  auto_614: '累计题量',
  auto_615: '打基础学习时长',
  auto_616: '小时',
  auto_617: '打基础掌握知识点',
  auto_618: '成长记录',
  auto_619: '时间',
  auto_620: '掌握知识点数',
  auto_621: '整体掌握程度',
  auto_622: '本月累计学习时长',
  auto_623: '目标学习时长',
  auto_624: '进步方案',
  auto_625: '新增目录信息',
  auto_626: '编辑目录信息',
  auto_627: '目录排序',
  auto_628: '目录名称',
  auto_629: '创建时间',
  auto_630: '创建人',
  auto_631: '学习轨迹',
  auto_633: '查看报告',
  auto_634: '立即咨询提升方案',
  auto_474: '结课成绩必须大于入学',
  auto_477: '开启成功',
  auto_478: '今日邀约知识漏洞大体检',
  auto_479: '邀约知识漏洞大体检入口>>',
  auto_480: '累计时长',
  auto_481: '小时',
  auto_482: '图形触发散点图饼图等',
  auto_483: '坐标轴触发',
  auto_484: '直线指示器',
  auto_485: '操作',
  auto_486: '无指示器',
  auto_487: '周一',
  auto_488: '周二',
  auto_489: '报告列表',
  auto_490: '周四',
  auto_491: '周五',
  auto_492: '周六',
  auto_493: '周日',
  auto_494: '小时',
  auto_495: '开启成功',
  auto_496: '关闭成功',
  auto_497: '开启成功',
  auto_498: '关闭成功',
  auto_499: '开启成功',
  auto_500: '体验中',
  auto_649: '选择学员',
  auto_650: '案例设置',
  auto_665: '案例标题',
  auto_666: '例学苗变学霸数学90天进步35分',
  auto_667: '学习科目',
  auto_669: '学习时间',
  auto_520: '选择学员的学习时间后',
  auto_670: '入学年级',
  auto_651: '学员基础信息',
  auto_671: '学员姓名',
  auto_672: '学员手机号',
  auto_673: '学习中心账号',
  auto_674: '学员类型',
  auto_675: '班主任',
  auto_676: '责任人',
  auto_677: '所在校区',
  auto_652: '分享设置',
  auto_678: '分享海报',
  auto_653: '学神大作战',
  auto_654: '请选择海报模板',
  auto_679: '留咨信息设置',
  auto_680: '手机号',
  auto_655: '临时保存',
  auto_656: '保存并发布',
  auto_683: '选择成绩',
  auto_657: '请选择学习前的成绩',
  auto_685: '考试类型',
  auto_686: '考试日期',
  auto_687: '成绩',
  auto_658: '新增成绩记录',
  auto_688: '新增成绩记录',
  auto_689: '科目',
  auto_690: '请选择科目',
  auto_691: '考试类型',
  auto_692: '请选择考试类型',
  auto_693: '考试日期',
  auto_694: '请选择考试日期',
  auto_695: '满分',
  auto_696: '请输入满分',
  auto_697: '成绩',
  auto_698: '请输入成绩',
  auto_699: '班级排名',
  auto_700: '请输入班级排名',
  auto_701: '年级排名',
  auto_702: '请输入年级排名',
  auto_705: '考卷照片',
  auto_706: '进步方案',
  auto_659: '进步课程安排',
  auto_707: '上课节数',
  auto_708: '请输入上课节数',
  auto_660: '节课',
  auto_709: '上课频率',
  auto_711: '请输入上课频率',
  auto_710: '请输入上课频率',
  auto_661: '节课周',
  auto_712: '每周打地基时长',
  auto_713: '请输入每周打地基时长',
  auto_662: '小时',
  auto_714: '选择海报模板',
  auto_663: '学神大作战',
  auto_521: '新增案例',
  auto_522: '小学',
  auto_530: '初中',
  auto_536: '高中',
  auto_540: '高四',
  auto_542: '手机号',
  auto_545: '学神大作战',
  auto_546: '编辑案例',
  auto_560: '用户详情',
  auto_578: '选择学员',
  auto_579: '请输入学员姓名或智适应账号',
  auto_561: '学员基础信息',
  auto_562: '学员姓名',
  auto_564: '所在区域',
  auto_567: '服务中心',
  auto_568: '案例基础设置',
  auto_580: '案例标题',
  auto_581: '学科',
  auto_582: '数学',
  auto_583: '英语',
  auto_584: '语文',
  auto_585: '物理',
  auto_586: '化学',
  auto_587: '生物',
  auto_588: '地理',
  auto_589: '科学',
  auto_590: '学习时间',
  auto_569: '最多选择180天',
  auto_570: '请选择阶段',
  auto_571: '案例分享设置',
  auto_572: '隐私',
  auto_573: '公开',
  auto_574: '金币',
  auto_575: '下载价格的50打入经销商账户另50为总部学霸基金用于总部活动',
  auto_576: '保存预览案例',
  auto_577: '保存并退出',
  auto_432: '手机号',
  auto_435: '年龄',
  auto_436: '就读学校',
  auto_437: '小学',
  auto_444: '初中',
  auto_448: '高中',
  auto_452: '小学',
  auto_459: '初中',
  auto_464: '高中',
  auto_468: '高四',
  auto_469: '模块类型学习报告学习',
  auto_359: '设备SN码',
  auto_360: '操作',
  auto_353: '手机号换绑',
  auto_354: '物流详情',
  auto_361: '账户手机换绑',
  auto_362: '学习机账户编号',
  auto_363: '学习机账户',
  auto_364: '代理商ID',
  auto_365: '代理商名称',
  auto_366: '原手机号',
  auto_367: '请填写原手机号',
  auto_372: '验证码',
  auto_369: '请输入验证码',
  auto_262: '发送验证码',
  auto_263: '重新发送',
  auto_370: '新手机号',
  auto_371: '请填写新手机号',
  auto_368: '验证码',
  auto_373: '请输入验证码',
  auto_264: '发送验证码',
  auto_265: '重新发送',
  auto_356: '下一步',
  auto_374: '物流详情',
  auto_375: '公司名称',
  auto_377: '快递单号',
  auto_358: '最新',
  auto_378: '学习机备注',
  auto_380: '请输入内容',
  auto_266: '商品名称',
  auto_267: '代理商',
  auto_268: '代理商名称',
  auto_269: '账户状态',
  auto_270: '设备状态',
  auto_271: '设备激活时间',
  auto_272: '账户激活时间',
  auto_273: '发货日期',
  auto_274: '快递公司',
  auto_275: '快递单号',
  auto_276: '物流状态',
  pleaseEnterExpressCompany: '请输入快递公司',
  pleaseEnterExpressNo: '请输入快递单号',
  pleaseSelectLogisticsStatus: '请选择物流状态',
  auto_277: '所属柜台',
  counterEquipmentSearchSnLabel: '设备SN码:',
  counterEquipmentSearchSnPlaceholder: '请输入设备SN码',
  counterEquipmentSearchProductNameLabel: '商品名称',
  counterEquipmentSearchProductNamePlaceholder: '请输入商品名称',
  counterEquipmentSearchAgentLabel: '代理商',
  counterEquipmentSearchCounterAssignTimeLabel: '柜台分配时间',
  auto_278: '分配柜台时间',
  auto_280: '未激活',
  auto_281: '已激活',
  auto_282: '冻结',
  auto_283: '已订阅',
  auto_382: '柜台类型',
  auto_383: '柜台编号',
  auto_384: '状态',
  auto_284: '待审核',
  auto_385: '柜台负责人',
  auto_386: '请输入柜台负责人姓名',
  auto_387: '负责人电话',
  auto_388: '请输入负责人电话',
  auto_389: '所在省市',
  auto_390: '柜台地址',
  auto_391: '请填写柜台地址',
  auto_392: '申请备注',
  auto_393: '请填写申请备注',
  auto_394: '柜台照片',
  auto_381: '合同协议',
  auto_395: '附件',
  auto_396: '操作',
  auto_397: '确认结果',
  auto_398: '请选择确认结果',
  auto_399: '确认备注',
  auto_400: '请填写备注',
  auto_401: '新增协议',
  auto_402: '文件类型',
  auto_403: '请选文件类型',
  auto_404: '租赁协议',
  auto_405: '补充协议',
  auto_406: '其他协议',
  auto_407: '签署时间',
  auto_409: '有效期',
  auto_410: '附件',
  auto_412: '请填写备注',
  auto_287: '文件类型',
  auto_288: '签署时间',
  auto_289: '有效期',
  auto_291: '创建时间',
  auto_292: '创建人',
  auto_293: '最新修改时间',
  auto_294: '待审核',
  auto_295: '租赁协议',
  auto_296: '补充协议',
  auto_297: '其他协议',
  auto_298: '附件',
  auto_762: '活动规则',
  auto_763: '活动状态',
  auto_755: '已暂停',
  auto_764: '发起人数',
  auto_765: '助力人数',
  auto_766: '人均助力人数',
  auto_767: '到店人数',
  auto_768: '助力到店转化率',
  auto_769: '操作',
  auto_756: '下载海报',
  auto_770: '创建活动',
  auto_771: '活动名称',
  auto_772: '请输入活动名称',
  auto_773: '活动时间',
  auto_774: '活动规则',
  auto_775: '输入奖品名',
  auto_757: '数量',
  auto_776: '输入奖品数量',
  auto_758: '2助力用户可获得888元体验大礼包同一手机号只可参与一次助力',
  auto_777: '输入现金金额',
  auto_759: '4助力用户体验卡核销地址',
  auto_778: '输入省市区路名街道号',
  auto_760: '联系方式',
  auto_779: '输入供助力用户联系的号码',
  auto_780: '下载二维码',
  auto_781: '下载海报',
  auto_761: '扫码领取福利',
  auto_208: '标记失效',
  auto_209: '数据迁移',
  auto_210: '如何获取更多例子',
  auto_230: '所属代理商',
  auto_231: '下次跟进时间',
  auto_238: '请输入学生姓名',
  auto_242: '请选择出生日期',
  auto_1244: '家庭成员',
  auto_2246: '家庭成员',
  auto_250: '添加跟进记录',
  auto_251: '跟进类型',
  auto_252: '请选择跟进类型',
  auto_254: '请输入跟进描述',
  auto_255: '跟进凭证',
  auto_256: '下次跟进时间',
  auto_257: '选择下次跟进时间',
  auto_258: '邀约大体检',
  auto_219: '客户手机号未进行验证',
  auto_220: '需验证客户手机号有效性后才可进行开通体验',
  auto_221: '发送验证码',
  auto_222: '下一步',
  auto_223: '有效期',
  auto_224: '账号',
  auto_227: '复制',
  auto_225: '复制',
  auto_211: '选择时间需要大于当前',
  auto_212: '请选择阶段年级',
  auto_237: '高四',
  auto_239: '批量导入的表格模板不',
  auto_414: 'sN码',
  auto_415: '请输入SN码',
  auto_416: '所属经销商',
  auto_417: '状态',
  auto_418: '报备激活地',
  auto_419: '经销商所在地',
  auto_420: '报备人',
  auto_421: '报备地代理商',
  auto_422: '审核代理商',
  auto_423: '上级代理商',
  auto_424: '报备时间',
  auto_425: '跨区类型',
  auto_426: '软件激活状态',
  auto_427: '复核结果',
  auto_428: '付款凭证',
  auto_413: '最多上传5个文件支持图片或PDF',
  auto_299: '文件',
  auto_429: '报备原因',
  auto_430: '请输入报备原因',
  auto_300: '操作时间',
  auto_301: '操作人',
  auto_302: '报备状态',
  auto_303: '账号',
  auto_305: '没有查询到学习机',
  auto_306: '复制',
  auto_307: '没有查询到学习机',
  auto_308: '新增报备',
  auto_309: '修改报备',
  auto_310: '重新报备',
  auto_311: '保存成功',
  auto_312: '开通体验',
  auto_313: '只能上传格式的图片及',
  auto_314: '获取跨区域类型和报备',
  auto_733: '活动ID',
  auto_744: '活动名称',
  auto_746: '活动规则',
  auto_736: '活动状态',
  auto_737: '活动投诉记录',
  auto_738: '发起人数',
  auto_739: '参与人数',
  auto_740: '留资人数',
  auto_741: '成交人数',
  auto_742: '操作',
  auto_732: '下载二维码',
  auto_743: '活动规则',
  auto_734: '活动名称',
  auto_745: '活动时间',
  auto_735: '活动规则',
  auto_747: '活动预览',
  auto_748: '活动投诉记录',
  auto_749: '序号',
  auto_750: '投诉原因',
  auto_751: '投诉具体描述',
  auto_752: '联系方式',
  auto_753: '投诉时间',
  auto_754: '下载二维码',
  auto_722: '标题',
  auto_723: '发布状态',
  auto_724: '审核状态',
  auto_725: '操作',
  auto_547: '下架',
  auto_548: '发布',
  auto_717: '上榜',
  auto_549: '下架',
  auto_550: '发布',
  auto_726: '上榜',
  auto_727: '案例名称',
  auto_728: '发布校区ID',
  auto_729: '发布校区名称',
  auto_730: '上榜类型',
  auto_719: '全国热度榜',
  auto_720: '省热度榜',
  auto_731: '上榜时间',
  auto_721: '关闭预览',
  auto_553: '已发布',
  auto_554: '未发布',
  auto_555: '已下架',
  auto_556: '未提交',
  auto_557: '审核通过',
  auto_558: '禁用',
  auto_559: '待审核',
  auto_330: '请选择预约时间',
  auto_331: '选择时间需要大于当前',
  auto_333: '手机号',
  auto_334: '邀约时间',
  auto_335: '账号',
  auto_336: '测试时间',
  auto_338: '测试状态',
  auto_342: '科目',
  auto_343: '版本',
  auto_344: '测试用时',
  auto_345: '单元',
  auto_346: '知识点掌握率',
  auto_347: '测试时间',
  auto_290: '数据迁移',
  auto_279: '1每个校区代理商仅能申请迁移一次数据且目标系统必须是代理商系',
  auto_285: '技术人员将在三个工作日内完成迁移请耐心等待',
  auto_194: '连接地址',
  auto_195: '企业编号',
  auto_196: 'sIP方式',
  auto_203: '登录',
  auto_204: '登出',
  auto_205: '登录',
  auto_206: '登出',
  auto_0197: '手机',
  auto_1198: 'sIP话机',
  auto_2199: 'webCallWebRtc软话机',
  auto_200: '登录方式',
  auto_201: '登录到的技能组保持空',
  auto_1204: '默认',
  auto_1202: '默认',
  auto_207: '监控功能使用如103csqy',
  auto_782: '返回新增推荐',
  auto_801: '选择学员',
  auto_802: '请输入学员姓名或智适应账号',
  auto_783: '学员基础信息',
  auto_784: '学员姓名',
  auto_786: '所在区域',
  auto_789: '服务中心',
  auto_803: '选手视频',
  auto_4790: '视频格式MP',
  auto_791: '视频时长1560秒',
  auto_792: '视频大小100M以内',
  auto_804: '亲笔短文',
  auto_793: '预览',
  auto_794: '选手详情',
  auto_795: '选择学员后预览',
  auto_796: '上传视频后预览',
  auto_797: '我和松鼠的故事',
  auto_798: '上传亲笔短文后预览',
  auto_800: '当前信息未保存是否离开并放弃保存',
  auto_1021: '新增目录',
  auto_1027: '操作',
  auto_1028: '分类名称',
  auto_1029: '输入分类目录的名称',
  auto_1030: '目录排序',
  auto_1031: '隐私设置',
  auto_1033: '输入分类目录的信息',
  auto_1026: '立即创建',
  auto_632: '资料数量',
  auto_635: '是否确定删除该分类',
  auto_501: '本月剩余体验额度：',
  auto_514: '操作',
  auto_502: '更多选项',
  auto_503: '再次邀约',
  auto_504: '确认体验',
  auto_506: '开通入门账号',
  auto_508: '复制',
  auto_507: '复制',
  auto_529: '请选择体验分析师',
  auto_511: '是否确认该用户已进行了体验',
  auto_513: '是否取消该用户的体验',
  auto_534: '活动模板',
  auto_535: '图片名字',
  auto_539: '请选择子标签',
  auto_20531: '支持jpgpng格式最佳尺寸1080x1920大小不超过',
  auto_348: '类型',
  auto_349: '状态',
  auto_350: '操作',
  auto_351: '原因名称',
  auto_352: '请输入失效原因名称',
  auto_248: '操作成功',
  auto_249: '操作成功',
  auto_253: '编辑失效原因',
  auto_1041: '标签名称',
  auto_1039: '状态',
  auto_1040: '操作',
  auto_1038: '标签名称',
  auto_1042: '请输入标签名称',
  auto_259: '操作成功',
  auto_260: '编辑标签',
  auto_261: '请输入修改标签的名称',
  auto_321: '来源名称',
  auto_318: '类型',
  auto_319: '状态',
  auto_320: '操作',
  auto_317: '来源名称',
  auto_322: '请输入来源名称',
  auto_241: '新增来源',
  auto_245: '编辑来源',
  auto_246: '请输入修改来源的名称',
  auto_1043: '邀请人A微信昵称',
  auto_1044: '邀请人A头像',
  auto_1045: '被邀请人B微信昵称',
  auto_1046: '被邀请人B头像',
  auto_1047: '被邀请人B手机号',
  auto_1048: '邀请进展',
  auto_1049: '邀请时间',
  auto_1050: '留资时间',
  auto_1059: '服务中心名称',
  auto_1060: '详细地址',
  auto_1061: '简要介绍',
  auto_1062: '简要介绍50500个字',
  auto_1063: '介绍图片',
  auto_1064: '联系人',
  auto_1065: '联系方式',
  auto_1066: '联系二维码',
  auto_505: '分以上',
  auto_1084: '节课周',
  auto_1085: '松鼠Ai智适应教育科技改变教育',
  auto_512: '打地基降级',
  auto_515: '打地基升级',
  auto_516: '打地基重学',
  auto_1052: '审核状态',
  auto_1053: '投票编号',
  auto_1054: '当前排名',
  auto_1055: '操作',
  auto_1056: '驳回原因',
  auto_1051: '确定撤回审核吗',
  auto_1072: '导入完成点击查看',
  auto_1073: '导入查询',
  auto_1074: '重新下载数据并返回上传',
  // PotentialCustomers/components/uploadProgress.vue（勿与 auto_651/652 混用，后者用于案例编辑区块标题）
  potentialImportCompleteTip: '导入完成，点击查看',
  potentialImportQueryLink: '导入查询',
  potentialImportReuploadBtn: '重新下载数据并返回上传',
  potentialImportRunningTip:
    '数据导入中，若误关闭当前网页和窗口，您可以在"导入查询"中查看本次操作',
  potentialImportFailureTip:
    '因服务器中断，部分数据导入失败，请重新下载数据并返回上传',
  auto_304: '复制',
  auto_1088: '开通账号',
  auto_1067: '操作提醒',
  auto_1068: '线索失效后将被记为无效数据不再线索列表中展示请确认是否继续标',
  auto_1070: '失效原因',
  auto_1071: '100字以内',
  auto_325: '信息不存在',
  auto_326: '发放失败',
  auto_327: '无法发放通行证',
  auto_329: '系统异常',
  auto_470: '是否需要发布此案例发',
  auto_471: '是否取消发布此案例取',
  auto_472: '发布成功',
  auto_473: '取消发布成功',
  auto_1075: '礼包领取状态',
  auto_1076: '操作',
  auto_1089: '开通外呼预售优惠',
  auto_648: '支付成功',
  auto_1082: '复制链接',
  auto_1083: '下载二维码',
  craaOperation: '操作',
  craaViewDetail: '查看详情',
  craaResubmit: '再次提交',
  craaQueryFailed: '查询失败',
  craaOnlyRejectedCanResubmit: '仅审核驳回的申诉可再次提交',
  craaAlreadyReportedNoNeedSubmit: '此设备已报备完成，无需提交。',
  craaPendingReviewNoRepeatSubmit: '此设备已有待审核申请，无需重复提交。',
  craaInObservationNoRepeatSubmit: '此设备目前在观测期，无需重复提交。',
  craaNoNeedSubmit: '此设备无需提交。',
  craaCheckResubmitStatusFailed: '校验再次提交状态失败',
  craaDeviceSnCode: '设备SN码',
  craaPleaseEnterDeviceSnCode: '请输入设备SN码',
  craaAppealStatus: '申诉状态',
  craaPleaseSelectAppealStatus: '请选择申诉状态',
  craaPendingReview: '待审核',
  craaReviewApproved: '审核通过',
  craaReviewRejected: '审核驳回',
  craaAppealTime: '申诉时间',
  craaPleaseSelectAppealSubmitTime: '请选择申诉提交时间',
  craaDeviceModel: '设备型号',
  craaDealerId: '经销商ID',
  craaDealerName: '经销商名称',
  craaDealerLocation: '经销商所在地',
  craaSoftwareActivationTime: '软件激活时间',
  craaSoftwareActivationProvinceCity: '软件激活省市区',
  craaCrossRegionActiveDate: '跨区域活跃日期',
  craaCrossRegionActiveProvinceCity: '跨区域活跃省市区',
  craaReviewAgentId: '审核代理商ID',
  craaReviewAgentName: '审核代理商名称',
  craaSubmitter: '提交方',
  craaAppealSubmitTime: '申诉提交时间',
  craaReviewTime: '审核时间',
  craaReviewer: '审核人',
  craaAppealDetailTitle: '跨区域活跃设备报备详情',
  craaLearningMachineSnCode: '学习机SN码',
  craaSituationDescription: '情况说明',
  craaPurchaseProof: '购买证明',
  craaReviewRemark: '审核备注',
  craaAppealRecordIdRequired: '申诉记录ID不能为空',
  craaFetchAppealDetailFailed: '获取申诉详情失败',
  craaReportTitle: '跨区域活跃设备报备',
  craaPleaseEnterSituationDescription: '请输入5至100字情况说明',
  craaUploadTip: '请上传购买凭证和与家长的沟通记录',
  craaPleaseEnterSituationDescriptionShort: '请输入情况说明',
  craaSituationDescriptionLengthRule: '情况说明需为5至100字',
  craaPleaseUploadPurchaseProof: '请上传购买证明',
  craaPurchaseProofUploadLimit: '购买证明最多上传9张图片',
  craaOnlyImageFormatsAllowed: '只能上传JPG、JPEG、PNG、BMP格式图片',
  craaImageSizeLimit: '图片大小不能超过20M',
  craaUploadFailed: '上传失败',
  craaImageUploadingWait: '图片上传中，请稍后再提交',
  craaResubmitSuccess: '再次提交成功',
  craaResubmitFailed: '再次提交失败',
  craaAddReport: '+新增报备',
  craaStatus: '状态',
  craaPleaseSelectStatus: '请选择状态',
  craaStatusNormal: '正常',
  craaStatusObservation: '观测期',
  craaStatusLocked: '已锁定',
  craaStatusPendingReview: '待审核',
  craaSoftwareActivationDate: '软件激活日期',
  craaPleaseSelectSoftwareActivationDateRange: '请选择软件激活日期范围',
  craaLockDate: '锁机日期',
  craaPleaseSelectLockDateRange: '请选择锁机日期范围',
  craaPleaseSelectDateRange: '请选择日期范围',
  craaDataSource: '数据来源',
  craaObservationEndDate: '观测结束日期',
  craaPleaseSelectCrossCityActiveArea: '请选择设备跨市活跃地',
  craaGetDealerInfoFailed: '获取经销商信息失败',
  craaPleaseEnterLearningMachineSnCode: '请输入学习机SN码',
  craaLearningMachineSnCodeLengthRule: '学习机SN码需在100个字符内',
  craaPleaseSelectCrossRegionActiveProvinceCity: '请选择跨区域活跃省市',
  craaGetProvinceCityDataFailed: '获取省市数据失败',
  craaAddReportSuccess: '新增报备成功',
  craaAddReportFailed: '新增报备失败',
  bphMarkBackupPhone: '标记备用机',
  bphBackupPhoneAvailableQuota: '备用机可用额度：',
  bphQuotaHelpTip: '备用机额度为经销商上月活跃学员的20%。',
  bphGetQuotaFailed: '获取备用机额度失败',
  bphQueryListFailed: '查询备用机列表失败',
  bphNoQuotaNow: '当前经销商已无备用机额度。',
  bphDeviceSnCode: '设备SN码',
  bphPleaseEnterDeviceSnCode: '请输入设备SN码',
  bphMarkTime: '标记时间',
  bphPleaseSelectMarkTimeRange: '请选择标记时间范围',
  bphDeviceModel: '设备型号',
  bphDealerId: '经销商ID',
  bphDealerName: '经销商名称',
  bphLocation: '所在地',
  bphDeviceHardwareStatus: '设备硬件状态',
  bphHardwareActivationDate: '硬件激活日期',
  bphMarkBackupPhoneDate: '标记备用机日期',
  bphDeviceSnCodeWithColon: '设备SN码:',
  bphDealerIdWithColon: '经销商ID:',
  bphDealerNameWithColon: '经销商名称:',
  bphDeviceSnCodeLengthRule: '设备SN码需在100个字符内',
  bphDeviceSnChecking: '设备SN校验中...',
  bphDeviceSnCheckPassed: '设备SN校验通过',
  bphDeviceSnCheckFailed: '设备SN校验失败',
  bphPleaseFinishDeviceSnCheckFirst: '请先完成设备SN校验',
  bphConfirmMarkDialogTitle: '确认标记',
  bphConfirmMarkDialogContent: '标记后，当前设备将恢复至软件未激活状态，且无法再次激活。标记后无法取消标记。是否确认标记备用机？',
  bphMarkBackupPhoneSuccess: '标记备用机成功',
  bphMarkBackupPhoneFailed: '标记备用机失败',
  improveCaseStatus: '案例状态',
  pleaseSelectImproveCaseStatus: '请选择案例状态',
  /** 营销-案例实例迁移 InstanceMigration（避免误用 qu/school/fen/time/status 等通用键） */
  instanceMigration_belongCampus: '所属校区',
  instanceMigration_selectBelongCampus: '请选择所属校区',
  instanceMigration_updateTimeColumn: '更新时间',
  instanceMigration_enterCaseNamePlaceholder: '请输入案例名称',
  instanceMigration_selectEnrollmentScore: '请选择入学成绩',
  instanceMigration_selectProgressScore: '请选择进步分数',
  instanceMigration_enterStudentAccount: '请输入学员账号',
  studentWithColon: '学员:',
  pleaseEnterNameOrAccount: '请输入姓名或账号',
  progressScoreRange5To10: '5～10分',
  progressScoreRangeAbove10: '10分以上',
  progressScoreRangeAbove20: '20分以上',
  progressScoreRangeAbove30: '30分以上',
  progressScoreRangeAbove40: '40分以上',
  enrolScoreRangeBelow40: '40分以下',
  enrolScoreRange41To60: '41～60分',
  enrolScoreRange61To80: '61～80分',
  enrolScoreRangeAbove81: '81分及以上',
  textyad6: '新增案例',
  textdif5: '系统提示',
  viewStudentHomework: '查看学员作业',
  practiceReport: '练习报告',
  answerRecord: '答题记录',
  followContent: '跟进内容',
  enterFollowContent: '请输入跟进内容',
  uploadJpgPngLimit500k: '上传jpg/png文件，且不超过500k',
  invitePhysicalExam: '邀约大体检',
  appointmentTime: '预约时间',
  selectAppointmentDate: '请选择预约日期',
  enterRemark: '请输入备注',
  openPhysicalExam: '开通体验',
  customerName2: '客户姓名',
  analyst: '分析师',
  selectAnalyst: '请选择分析师',
  inviteKnowledgeExam: '邀约大体检成功',
  inviteKnowledgeExam2: '邀约大体检',
  inviteKnowledgeExamTime: '邀约大体检时间',
  account: '账号',
  password: '密码',
  homeworkName: '作业名称',
  dingtalkUsername: '钉钉用户名',
  nextFollow: '下次跟进',
  uploadImageFormat: '请上传jpg/png格式图片',
  grade10: '高一',
  grade11: '高二',
  grade12: '高三',
  grade13: '复读',
  general170: '小升初',
  general175: '初升高',
  general180: '高考',
  export: '导出',
  briefIntroLength50_500: '简介字数需为50-500字',
  catalogNameMax10: '目录名称最多10个字',
  length2To10: '请输入2~10个字',
  numberMax99: '请输入1~99的整数',
  pleaseEnterPassword6_32: '请输入密码，一般为6到32位的英语字母和数字',
  reasonLength5_100: '填写原因字数在5-100字',
  inviteRewardTier4MoreThanTier3: '阶梯四邀请奖励金额须大于阶梯三',
  storeRewardTier4MoreThanTier3: '阶梯四到店奖励金额须大于阶梯三',
  no0: '否',
  yes1: '是',
  webCall1: 'WebCall',
  webRtc2: 'WebRTC',
  ccs1: 'CCS',
  cti2: 'CTI',
  prototypeMarkWarning: '学习机一旦标记为样机，将不可修改',
  textfpck: '查看规划报告',
  textybol: '查看报告',
  textata5: '确认',
  textctp8: '确定',
  textew92: '取消',
  textve0v: '上传附件',
  text1eqj: '复制并导入',
  text3k7c: '复制',
  textg7yv: '复制链接',
  textqtuz: '下载模板',
  textraz2: '全部导出',
  textxb1x: '导出',
  text0yuv: '选择登录类型:',
  texti3fa: '登录类型:',
  textl78x: '是否预测外呼:',
  textuztd: '客户端话机类型:',
  text5gyv: '服务端类型:',
  ruleSettingAddTag: '添加标签',
  ruleSettingAddSource: '添加来源',
  ruleSettingAddExpireReason: '添加失效原因',
  activityGalleryPictureNameLabel: '图片名字：',
  activityGalleryPictureNamePlaceholder: '请输入模板名称',
  activityGalleryTemplateTypesLabel: '模板类型:',
  activityGalleryTemplateTypesPlaceholder: '请选择模板类型',
  activityGalleryTagLabel: '标签:',
  activityGalleryTagTypePlaceholder: '标签类型',
  activityGalleryTagIdsPlaceholder: '标签',
  activityGalleryAddTemplateButton: '新增活动模板',
  activityGalleryDeleteImageButton: '删除图片',
  }
};
